/* eslint-disable */
/**
 * 全局对象有Taf、HUYA、
 */
; (function () {
    // taf的基础库
    var Taf = window.Taf || {};
    window.Taf = Taf;
  
    Taf.INT8 = function () {
      this._clone = function () {
        return 0;
      }
      this._write = function (os, tag, val) {
        return os.writeInt8(tag, val);
      }
      this._read = function (is, tag, def) {
        return is.readInt8(tag, true, def);
      }
      this._className = function () {
        return Taf.CHAR;
      }
    };
    Taf.INT16 = function () {
      this._clone = function () {
        return 0;
      }
      this._write = function (os, tag, val) {
        return os.writeInt16(tag, val);
      }
      this._read = function (is, tag, def) {
        return is.readInt16(tag, true, def);
      }
      this._className = function () {
        return Taf.SHORT;
      }
    };
    Taf.INT32 = function () {
      this._clone = function () {
        return 0;
      }
      this._write = function (os, tag, val) {
        return os.writeInt32(tag, val);
      }
      this._read = function (is, tag, def) {
        return is.readInt32(tag, true, def);
      }
      this._className = function () {
        return Taf.INT32;
      }
    };
    Taf.INT64 = function () {
      this._clone = function () {
        return 0;
      }
      this._write = function (os, tag, val) {
        return os.writeInt64(tag, val);
      }
      this._read = function (is, tag, def) {
        return is.readInt64(tag, true, def);
      }
      this._className = function () {
        return Taf.INT64;
      }
    };
    Taf.UINT8 = function () {
      this._clone = function () {
        return 0;
      }
      this._write = function (os, tag, val) {
        return os.writeInt16(tag, val);
      }
      this._read = function (is, tag, def) {
        return is.readInt16(tag, true, def);
      }
      this._className = function () {
        return Taf.SHORT;
      }
    };
    Taf.UInt16 = function () {
      this._clone = function () {
        return 0;
      }
      this._write = function (os, tag, val) {
        return os.writeInt32(tag, val);
      }
      this._read = function (is, tag, def) {
        return is.readInt32(tag, true, def);
      }
      this._className = function () {
        return Taf.INT32;
      }
    };
    Taf.UInt32 = function () {
      this._clone = function () {
        return 0;
      }
      this._write = function (os, tag, val) {
        return os.writeInt64(tag, val);
      }
      this._read = function (is, tag, def) {
        return is.readInt64(tag, true, def);
      }
      this._className = function () {
        return Taf.INT64;
      }
    };
    Taf.Float = function () {
      this._clone = function () {
        return 0;
      }
      this._write = function (os, tag, val) {
        return os.writeFloat(tag, val);
      }
      this._read = function (is, tag, def) {
        return is.readFloat(tag, true, def);
      }
      this._className = function () {
        return Taf.FLOAT;
      }
    };
    Taf.Double = function () {
      this._clone = function () {
        return 0;
      }
      this._write = function (os, tag, val) {
        return os.writeDouble(tag, val);
      }
      this._read = function (is, tag, def) {
        return is.readDouble(tag, true, def);
      }
      this._className = function () {
        return Taf.DOUBLE;
      }
    };
    Taf.STRING = function () {
      this._clone = function () {
        return 0;
      }
      this._write = function (os, tag, val) {
        return os.writeString(tag, val);
      }
      this._read = function (is, tag, def) {
        return is.readString(tag, true, def);
      }
      this._className = function () {
        return Taf.STRING;
      }
    };
    Taf.BOOLEAN = function () {
      this._clone = function () {
        return false;
      }
      this._write = function (os, tag, val) {
        return os.writeBoolean(tag, val);
      }
      this._read = function (is, tag, def) {
        return is.readBoolean(tag, true, def);
      }
      this._className = function () {
        return Taf.BOOLEAN;
      }
    };
    Taf.ENUM = function () {
      this._clone = function () {
        return 0;
      }
      this._write = function (os, tag, val) {
        return os.writeInt32(tag, val);
      }
      this._read = function (is, tag, def) {
        return is.readInt32(tag, true, def);
      }
    };
  
    /**
     * TAFVECTOR实现类
     */
    Taf.Vector = function (proto) {
      this.proto = proto;
      this.value = new Array();
    }
    Taf.Vector.prototype._clone = function () {
      return new Taf.Vector(this.proto);
    }
    Taf.Vector.prototype._write = function (os, tag, val) {
      return os.writeVector(tag, val);
    }
    Taf.Vector.prototype._read = function (is, tag, def) {
      return is.readVector(tag, true, def);
    }
    Taf.Vector.prototype._className = function () {
      return Taf.TypeHelp.VECTOR.replace("$t", this.proto._className());
    }
  
    /**
     * TAFMAP实现类
     */
    Taf.Map = function (kproto, vproto) {
      this.kproto = kproto;
      this.vproto = vproto;
      this.value = new Object();
    };
    Taf.Map.prototype._clone = function () {
      return new Taf.Map(this.kproto, this.vproto);
    }
    Taf.Map.prototype._write = function (os, tag, val) {
      return os.writeMap(tag, val);
    }
    Taf.Map.prototype._read = function (is, tag, def) {
      return is.readMap(tag, true, def);
    }
    Taf.Map.prototype.put = function (key, value) {
      this.value[key] = value;
    }
    Taf.Map.prototype.get = function (key) {
      return this.value[key];
    }
    Taf.Map.prototype.remove = function (key) {
      delete this.value[key];
    }
    Taf.Map.prototype.clear = function () {
      this.value = new Object();
    }
    Taf.Map.prototype.size = function () {
      var anum = 0;
      for (var key in this.value) {
        anum++;
      }
      return anum;
    };
    Taf.Map.prototype._className = function () {
      return Taf.TypeHelp.Map.replace("$k", this.kproto._className()).replace("$v", this.vproto._className());
    }
  
    /**
     * KevinTian@tencent.com
     *
     * JCE编解码底层辅助类
     */
    Taf.DataHelp = {
      EN_INT8: 0,
      EN_INT16: 1,
      EN_INT32: 2,
      EN_INT64: 3,
      EN_FLOAT: 4,
      EN_DOUBLE: 5,
      EN_STRING1: 6,
      EN_STRING4: 7,
      EN_MAP: 8,
      EN_LIST: 9,
      EN_STRUCTBEGIN: 10,
      EN_STRUCTEND: 11,
      EN_ZERO: 12,
      EN_SIMPLELIST: 13
    };
  
    Taf.TypeHelp = {
      BOOLEAN: "bool",
      CHAR: "char",
      SHORT: "short",
      INT32: "int32",
      INT64: "int64",
      FLOAT: "float",
      DOUBLE: "double",
      STRING: "string",
      VECTOR: "list<$t>",
      MAP: "map<$k, $v>",
    };
  
    /**
     * 二进制Buffer类
     */
    Taf.BinBuffer = function (buffer) {
      this.buf = null;
      this.vew = null;
      this.len = 0;
      this.position = 0;
  
      if (buffer != null && buffer != undefined && buffer instanceof Taf.BinBuffer) {
        this.buf = buffer.buf;
        this.vew = new DataView(this.buf);
        this.len = buffer.length;
        this.position = buffer.position;
      }
      if (buffer != null && buffer != undefined && buffer instanceof ArrayBuffer) {
        this.buf = buffer;
        this.vew = new DataView(this.buf);
        this.len = this.vew.byteLength;
        this.position = 0;
      }
  
      this.__defineGetter__("length", function () {
        return this.len;
      });
      this.__defineGetter__("buffer", function () {
        return this.buf;
      });
    };
  
    Taf.BinBuffer.prototype._write = function (os, tag, val) {
      return os.writeBytes(tag, val);
    }
  
    Taf.BinBuffer.prototype._read = function (os, tag, def) {
      return os.readBytes(tag, true, def);
    }
  
    Taf.BinBuffer.prototype._clone = function () {
      return new Taf.BinBuffer();
    }
  
    Taf.BinBuffer.prototype.allocate = function (uiLength) {
      uiLength = this.position + uiLength;
      if (this.buf != null && this.buf.length > uiLength) {
        return;
      }
  
      var temp = new ArrayBuffer(Math.max(256, uiLength * 2));
      if (this.buf != null) {
        new Uint8Array(temp).set(new Uint8Array(this.buf));
        this.buf = undefined;
      }
  
      this.buf = temp;
      this.vew = undefined;
      this.vew = new DataView(this.buf);
    };
  
    Taf.BinBuffer.prototype.getBuffer = function () {
      var temp = new ArrayBuffer(this.len);
      new Uint8Array(temp).set(new Uint8Array(this.buf, 0, this.len));
      return temp;
    }
  
    Taf.BinBuffer.prototype.memset = function (fbuf, offset, length) {
      this.allocate(length);
      new Uint8Array(this.buf).set(new Uint8Array(fbuf, offset, length), this.position);
    };
  
    Taf.BinBuffer.prototype.writeInt8 = function (value) {
      this.allocate(1);
      this.vew.setInt8(this.position, value);
      this.position += 1;
      this.len = this.position;
    };
  
    Taf.BinBuffer.prototype.writeUInt8 = function (value) {
      this.allocate(1);
      this.vew.setUint8(this.position++, value);
      this.len = this.position;
    };
  
    Taf.BinBuffer.prototype.writeInt16 = function (value) {
      this.allocate(2);
      this.vew.setInt16(this.position, value);
      this.position += 2;
      this.len = this.position;
    };
  
    Taf.BinBuffer.prototype.writeUInt16 = function (value) {
      this.allocate(2);
      this.vew.setUint16(this.position, value);
      this.position += 2;
      this.len = this.position;
    };
  
    Taf.BinBuffer.prototype.writeInt32 = function (value) {
      this.allocate(4);
      this.vew.setInt32(this.position, value);
      this.position += 4;
      this.len = this.position;
    };
  
    Taf.BinBuffer.prototype.writeUInt32 = function (value) {
      this.allocate(4);
      this.vew.setUint32(this.position, value);
      this.position += 4;
      this.len = this.position;
    };
  
    // Taf.BinBuffer.prototype.writeInt64 = function (value) {
    //   this.allocate(8);
    //   this.vew.setUint32(this.position, parseInt(value / 4294967296));
    //   this.vew.setUint32(this.position + 4, value % 4294967296);
    //   this.position += 8;
    //   this.len = this.position;
    // };
  
    Taf.BinBuffer.prototype.writeInt64 = function (value) {
      if (typeof value == 'string') {
        this.allocate(8);
        value = value.toLowerCase();
        var div = 4294967296;
        var low = 0;
        var hight = 0;
        for (var i = 0; i < value.length; i++) {
          var num = value.charCodeAt(i) - 48;
          if (num > 9) {
            num = num - 39;
          }
          low = low * 10 + num;
          var dd = Math.floor(low / div);
          hight = hight * 10 + dd;
          low = low % div;
        }
        this.vew.setUint32(this.position, hight);
        this.vew.setUint32(this.position + 4, low);
        this.position += 8;
        this.len = this.position;
        return;
      }
      this.allocate(8);
      this.vew.setUint32(this.position, parseInt(value / 4294967296));
      this.vew.setUint32(this.position + 4, value % 4294967296);
      this.position += 8;
      this.len = this.position;
    };
  
    Taf.BinBuffer.prototype.writeFloat = function (value) {
      this.allocate(4);
      this.vew.setFloat32(this.position, value);
      this.position += 4;
      this.len = this.position;
    };
  
    Taf.BinBuffer.prototype.writeDouble = function (value) {
      this.allocate(8);
      this.vew.setFloat64(this.position, value);
      this.position += 8;
      this.len = this.position;
    };
  
    Taf.BinBuffer.prototype.writeString = function (value) {
      for (var arr = [], i = 0; i < value.length; i++) {
        arr.push(value.charCodeAt(i) & 0xFF);
      }
  
      this.allocate(arr.length);
      new Uint8Array(this.buf).set(new Uint8Array(arr), this.position);
      this.position += arr.length;
      this.len = this.position;
    };
  
    Taf.BinBuffer.prototype.writeBytes = function (value) {
      if (value.length == 0 || value.buf == null) return;
  
      this.allocate(value.length);
      new Uint8Array(this.buf).set(new Uint8Array(value.buf, 0, value.length), this.position);
      this.position += value.length;
      this.len = this.position;
    };
  
    Taf.BinBuffer.prototype.readInt8 = function () {
      return this.vew.getInt8(this.position++);
    };
  
    Taf.BinBuffer.prototype.readInt16 = function () {
      this.position += 2;
      return this.vew.getInt16(this.position - 2);
    };
  
    Taf.BinBuffer.prototype.readInt32 = function () {
      this.position += 4;
      return this.vew.getInt32(this.position - 4);
    };
  
    Taf.BinBuffer.prototype.readUInt8 = function () {
      this.position += 1;
      return this.vew.getUint8(this.position - 1);
    };
  
    Taf.BinBuffer.prototype.readUInt16 = function () {
      this.position += 2;
      return this.vew.getUint16(this.position - 2);
    };
  
    Taf.BinBuffer.prototype.readUInt32 = function () {
      this.position += 4;
      return this.vew.getUint32(this.position - 4);
    };
  
    // Taf.BinBuffer.prototype.readInt64 = function () {
    //   var H4 = this.vew.getUint32(this.position);
    //   var L4 = this.vew.getUint32(this.position + 4);
    //   this.position += 8;
    //   return H4 * 4294967296 + L4;
    // };
  
    Taf.BinBuffer.prototype.readInt64 = function () {
      var H4 = this.vew.getUint32(this.position);
      var L4 = this.vew.getUint32(this.position + 4);
      this.position += 8;
      var result = "";
      var highRemain, lowRemain, tempNum;
      var MaxLowUint = Math.pow(2, 32);
      var radix = 10;
      while (H4 != 0 || L4 != 0) {
        highRemain = (H4 % radix);
        tempNum = highRemain * MaxLowUint + L4;
        lowRemain = tempNum % radix;
        result = lowRemain.toString(radix) + result;
        H4 = (H4 - highRemain) / radix;
        L4 = (tempNum - lowRemain) / radix;
      }
      return result;
    };
  
    Taf.BinBuffer.prototype.readFloat = function () {
      var temp = this.vew.getFloat32(this.position);
      this.position += 4;
      return temp;
    }
  
    Taf.BinBuffer.prototype.readDouble = function () {
      var temp = this.vew.getFloat64(this.position);
      this.position += 8;
      return temp;
    }
  
    Taf.BinBuffer.prototype.readString = function (value) {
      for (var arr = [], i = 0; i < value; i++) {
        arr.push(String.fromCharCode(this.vew.getUint8(this.position++)));
      }
      var result = arr.join("");
      try {
        result = decodeURIComponent(escape(result));
      } catch (e) { }
      //统一转义
      result = result.replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\'/g, '&#39;')
        .replace(/\"/g, '&quot;');
      return result;
    };
  
    Taf.BinBuffer.prototype.readBytes = function (value) {
      var temp = new Taf.BinBuffer();
      temp.allocate(value);
      temp.memset(this.buf, this.position, value);
      temp.position = 0;
      temp.len = value;
      this.position = this.position + value;
      return temp;
    };
  
    /**
     * TAFJCE输出编解码包裹类
     *
     * KevinTian@tencent.com
     */
    Taf.JceOutputStream = function () {
      this.buf = new Taf.BinBuffer();
      this.getBinBuffer = function () {
        return this.buf;
      }
      this.getBuffer = function () {
        return this.buf.getBuffer();
      }
    }
  
    Taf.JceOutputStream.prototype.clear = function () {
      this.buf = new Taf.BinBuffer();
      return this;
    };
  
    Taf.JceOutputStream.prototype.writeTo = function (tag, type) {
      if (tag < 15) {
        this.buf.writeUInt8((tag << 4 & 0xF0) | type);
      } else {
        this.buf.writeUInt16((0xF0 | type) << 8 | tag);
      }
    };
  
    Taf.JceOutputStream.prototype.writeBoolean = function (tag, value) {
      this.writeInt8(tag, value == true ? 1 : 0);
    };
  
    Taf.JceOutputStream.prototype.writeInt8 = function (tag, value) {
      if (value == 0) {
        this.writeTo(tag, Taf.DataHelp.EN_ZERO);
      } else {
        this.writeTo(tag, Taf.DataHelp.EN_INT8);
        this.buf.writeInt8(value);
      }
    };
  
    Taf.JceOutputStream.prototype.writeInt16 = function (tag, value) {
      if (value >= -128 && value <= 127) {
        this.writeInt8(tag, value);
      } else {
        this.writeTo(tag, Taf.DataHelp.EN_INT16);
        this.buf.writeInt16(value);
      }
    }
  
    Taf.JceOutputStream.prototype.writeInt32 = function (tag, value) {
      if (value >= -32768 && value <= 32767) {
        this.writeInt16(tag, value);
      } else {
        this.writeTo(tag, Taf.DataHelp.EN_INT32);
        this.buf.writeInt32(value);
      }
    }
  
    Taf.JceOutputStream.prototype.writeInt64 = function (tag, value) {
      if (value >= -2147483648 && value <= 2147483647) {
        this.writeInt32(tag, value);
      } else {
        this.writeTo(tag, Taf.DataHelp.EN_INT64);
        this.buf.writeInt64(value);
      }
    }
  
    Taf.JceOutputStream.prototype.writeUInt8 = function (tag, value) {
      this.writeInt16(tag, value);
    }
  
    Taf.JceOutputStream.prototype.writeUInt16 = function (tag, value) {
      this.writeInt32(tag, value);
    }
  
    Taf.JceOutputStream.prototype.writeUInt32 = function (tag, value) {
      this.writeInt64(tag, value);
    }
  
    Taf.JceOutputStream.prototype.writeFloat = function (tag, value) {
      if (value == 0) {
        this.writeTo(tag, Taf.DataHelp.EN_ZERO);
      } else {
        this.writeTo(tag, Taf.DataHelp.EN_FLOAT);
        this.buf.writeFloat(value);
      }
    }
  
    Taf.JceOutputStream.prototype.writeDouble = function (tag, value) {
      if (value == 0) {
        this.writeTo(tag, Taf.DataHelp.EN_ZERO);
      } else {
        this.writeTo(tag, Taf.DataHelp.EN_DOUBLE);
        this.buf.writeDouble(value);
      }
    }
  
    Taf.JceOutputStream.prototype.writeStruct = function (tag, value) {
      if (value.writeTo == undefined) {
        throw Error("not defined writeTo Function");
      }
  
      this.writeTo(tag, Taf.DataHelp.EN_STRUCTBEGIN);
      value.writeTo(this);
      this.writeTo(0, Taf.DataHelp.EN_STRUCTEND);
    }
  
    Taf.JceOutputStream.prototype.writeString = function (tag, value) {
      var str = value;
      try {
        str = unescape(encodeURIComponent(str));
      } catch (e) { }
      if (str.length > 255) {
        this.writeTo(tag, Taf.DataHelp.EN_STRING4);
        this.buf.writeUInt32(str.length);
      } else {
        this.writeTo(tag, Taf.DataHelp.EN_STRING1);
        this.buf.writeUInt8(str.length);
      }
      this.buf.writeString(str);
    };
  
    Taf.JceOutputStream.prototype.writeBytes = function (tag, value) {
      if (!(value instanceof Taf.BinBuffer)) {
        throw Error("value not instanceof Taf.BinBuffer");
      }
  
      this.writeTo(tag, Taf.DataHelp.EN_SIMPLELIST);
      this.writeTo(0, Taf.DataHelp.EN_INT8);
      this.writeInt32(0, value.length);
      this.buf.writeBytes(value);
    };
  
    Taf.JceOutputStream.prototype.writeVector = function (tag, value) {
      this.writeTo(tag, Taf.DataHelp.EN_LIST);
      this.writeInt32(0, value.value.length);
      for (var i = 0; i < value.value.length; i++) {
        value.proto._write(this, 0, value.value[i]);
      }
    };
  
    Taf.JceOutputStream.prototype.writeMap = function (tag, value) {
      this.writeTo(tag, Taf.DataHelp.EN_MAP);
      this.writeInt32(0, value.size());
  
      for (var temp in value.value) {
        value.kproto._write(this, 0, temp);
        value.vproto._write(this, 1, value.value[temp]);
      }
    };
  
    /**
     * TAFJCE输入编解码包裹类
     *
     * KevinTian@tencent.com
     */
    Taf.JceInputStream = function (buffer) {
      this.buf = new Taf.BinBuffer(buffer);
    };
  
    Taf.JceInputStream.prototype.setBuffer = function (arrayBuffer) {
      this.buf = new Taf.BinBuffer(arrayBuffer);
      return this;
    };
  
    Taf.JceInputStream.prototype.readFrom = function () {
      var temp = this.buf.readUInt8();
      var tag = (temp & 0xF0) >> 4;
      var type = (temp & 0x0F);
  
      if (tag >= 15) tag = this.buf.readUInt8();
      return {
        tag: tag,
        type: type
      };
    };
  
    Taf.JceInputStream.prototype.peekFrom = function () {
      var pos = this.buf.position;
      var head = this.readFrom();
      this.buf.position = pos;
  
      return {
        tag: head.tag,
        type: head.type,
        size: (head.tag >= 15) ? 2 : 1
      };
    };
  
    Taf.JceInputStream.prototype.skipField = function (type) {
      switch (type) {
        case Taf.DataHelp.EN_INT8:
          this.buf.position += 1;
          break;
        case Taf.DataHelp.EN_INT16:
          this.buf.position += 2;
          break;
        case Taf.DataHelp.EN_INT32:
          this.buf.position += 4;
          break;
        case Taf.DataHelp.EN_INT64:
          this.buf.position += 8;
          break;
        case Taf.DataHelp.EN_STRING1:
          var a = this.buf.readUInt8();
          this.buf.position += a;
          break;
        case Taf.DataHelp.EN_STRING4:
          var b = this.buf.readInt32();
          this.buf.position += b;
          break;
        case Taf.DataHelp.EN_STRUCTBEGIN:
          this.skipToStructEnd();
          break;
        case Taf.DataHelp.EN_STRUCTEND:
        case Taf.DataHelp.EN_ZERO:
          break;
        case Taf.DataHelp.EN_MAP:
          {
            var size = this.readInt32(0, true);
  
            for (var i = 0; i < size * 2; ++i) {
              var head = this.readFrom();
              this.skipField(head.type);
            }
  
            break;
          }
        case Taf.DataHelp.EN_SIMPLELIST:
          {
            var head = this.readFrom();
            if (head.type != Taf.DataHelp.EN_INT8) {
              throw Error("skipField with invalid type, type value: " + type + "," + head.type);
            }
  
            var a = this.readInt32(0, true);
            this.buf.position += a;
            break;
          }
        case Taf.DataHelp.EN_LIST:
          {
            var size = this.readInt32(0, true);
            for (var i = 0; i < size; ++i) {
              var head = this.readFrom();
              this.skipField(head.type);
            }
            break;
          }
        default:
          throw new Error("skipField with invalid type, type value: " + type);
      }
    }
  
    Taf.JceInputStream.prototype.skipToStructEnd = function () {
      for (; ;) {
        var head = this.readFrom();
        this.skipField(head.type);
  
        if (head.type == Taf.DataHelp.EN_STRUCTEND) {
          return;
        }
      }
    }
  
    Taf.JceInputStream.prototype.skipToTag = function (tag, require) {
      while (this.buf.position < this.buf.length) {
        var head = this.peekFrom();
        if (tag <= head.tag || head.type == Taf.DataHelp.EN_STRUCTEND) {
          // if ((head.type == Taf.DataHelp.EN_STRUCTEND || tag != head.tag) && require) {
          //     break;
          // }
          // return true;
          return head.type == Taf.DataHelp.EN_STRUCTEND ? false : (tag == head.tag);
        }
  
        this.buf.position += head.size;
        this.skipField(head.type);
      }
  
      if (require) throw Error("require field not exist, tag:" + tag);
      return false;
    }
  
    Taf.JceInputStream.prototype.readBoolean = function (tag, require, def) {
      return this.readInt8(tag, require, def) == 1 ? true : false;
    }
  
    Taf.JceInputStream.prototype.readInt8 = function (tag, require, def) {
      if (this.skipToTag(tag, require) == false) {
        return def;
      }
  
      var head = this.readFrom();
      switch (head.type) {
        case Taf.DataHelp.EN_ZERO:
          return 0;
        case Taf.DataHelp.EN_INT8:
          return this.buf.readInt8();
      }
      throw Error("read int8 type mismatch, tag:" + tag + ", get type:" + head.type);
    }
  
    Taf.JceInputStream.prototype.readInt16 = function (tag, require, def) {
      if (this.skipToTag(tag, require) == false) {
        return def;
      }
  
      var head = this.readFrom();
      switch (head.type) {
        case Taf.DataHelp.EN_ZERO:
          return 0;
        case Taf.DataHelp.EN_INT8:
          return this.buf.readInt8();
        case Taf.DataHelp.EN_INT16:
          return this.buf.readInt16();
      }
      throw Error("read int16 type mismatch, tag:" + tag + ", get type:" + head.type);
    }
  
    Taf.JceInputStream.prototype.readInt32 = function (tag, requrire, def) {
      if (this.skipToTag(tag, requrire) == false) {
        return def;
      }
  
      var head = this.readFrom();
      switch (head.type) {
        case Taf.DataHelp.EN_ZERO:
          return 0;
        case Taf.DataHelp.EN_INT8:
          return this.buf.readInt8();
        case Taf.DataHelp.EN_INT16:
          return this.buf.readInt16();
        case Taf.DataHelp.EN_INT32:
          return this.buf.readInt32();
      }
      throw Error("read int32 type mismatch, tag:" + tag + ", get type:" + head.type);
    }
  
    Taf.JceInputStream.prototype.readInt64 = function (tag, require, def) {
      if (this.skipToTag(tag, require) == false) {
        return def;
      }
  
      var head = this.readFrom();
      switch (head.type) {
        case Taf.DataHelp.EN_ZERO:
          return 0;
        case Taf.DataHelp.EN_INT8:
          return this.buf.readInt8();
        case Taf.DataHelp.EN_INT16:
          return this.buf.readInt16();
        case Taf.DataHelp.EN_INT32:
          return this.buf.readInt32();
        case Taf.DataHelp.EN_INT64:
          return this.buf.readInt64();
      }
      throw Error("read int64 type mismatch, tag:" + tag + ", get type:" + head.type);
    }
  
    Taf.JceInputStream.prototype.readFloat = function (tag, require, def) {
      if (this.skipToTag(tag, require) == false) {
        return def;
      }
  
      var head = this.readFrom();
      switch (head.type) {
        case Taf.DataHelp.EN_ZERO:
          return 0;
        case Taf.DataHelp.EN_FLOAT:
          return this.buf.readFloat();
      }
      throw Error("read float type mismatch, tag:" + tag + ", get type:" + h.type);
    }
  
    Taf.JceInputStream.prototype.readDouble = function (tag, require, def) {
      if (this.skipToTag(tag, require) == false) {
        return def;
      }
  
      var head = this.readFrom();
      switch (head.type) {
        case Taf.DataHelp.EN_ZERO:
          return 0;
        case Taf.DataHelp.EN_DOUBLE:
          return this.buf.readDouble();
      }
      throw Error("read double type mismatch, tag:" + tag + ", get type:" + h.type);
    }
  
    Taf.JceInputStream.prototype.readUInt8 = function (tag, require, def) {
      return this.readInt16(tag, require, def);
    }
  
    Taf.JceInputStream.prototype.readUInt16 = function (tag, require, def) {
      return this.readInt32(tag, require, def);
    }
  
    Taf.JceInputStream.prototype.readUInt32 = function (tag, require, def) {
      return this.readInt64(tag, require, def);
    }
  
    Taf.JceInputStream.prototype.readStruct = function (tag, require, def) {
      if (this.skipToTag(tag, require) == false) {
        return def;
      }
  
      var head = this.readFrom();
      if (head.type != Taf.DataHelp.EN_STRUCTBEGIN) {
        throw Error("read struct type mismatch, tag: " + tag + ", get type:" + head.type);
      }
  
      def.readFrom(this);
      this.skipToStructEnd();
      return def;
    }
  
    Taf.JceInputStream.prototype.readString = function (tag, require, def) {
      if (this.skipToTag(tag, require) == false) {
        return def;
      }
  
      var head = this.readFrom();
      if (head.type == Taf.DataHelp.EN_STRING1) {
        return this.buf.readString(this.buf.readUInt8());
      }
  
      if (head.type == Taf.DataHelp.EN_STRING4) {
        return this.buf.readString(this.buf.readUInt32());
      }
  
      throw Error("read 'string' type mismatch, tag: " + tag + ", get type: " + head.type + ".");
    }
  
    Taf.JceInputStream.prototype.readString2 = function (tag, require, def) {
      if (this.skipToTag(tag, require) == false) {
        return def;
      }
  
      var head = this.readFrom();
      if (head.type == Taf.DataHelp.EN_STRING1) {
        return this.buf.readBytes(this.buf.readUInt8());
      }
  
      if (head.type == Taf.DataHelp.EN_STRING4) {
        return this.buf.readBytes(this.buf.readUInt32());
      }
  
      throw Error("read 'string2' type mismatch, tag: " + tag + ", get type: " + head.type + ".");
    }
  
    Taf.JceInputStream.prototype.readBytes = function (tag, require, def) {
      if (this.skipToTag(tag, require) == false) {
        return def;
      }
  
      var head = this.readFrom();
      if (head.type == Taf.DataHelp.EN_SIMPLELIST) {
        var temp = this.readFrom();
        if (temp.type != Taf.DataHelp.EN_INT8) {
          throw Error("type mismatch, tag:" + tag + ",type:" + head.type + "," + temp.type);
        }
        var size = this.readInt32(0, true);
        if (size < 0) {
          throw Error("invalid size, tag:" + tag + ",type:" + head.type + "," + temp.type);
        }
  
        return this.buf.readBytes(size);
      }
  
      if (head.type == Taf.DataHelp.EN_LIST) {
        var size = this.readInt32(0, true);
        return this.buf.readBytes(size);
      }
  
      throw Error("type mismatch, tag:" + tag + ",type:" + head.type);
    }
  
    Taf.JceInputStream.prototype.readVector = function (tag, require, def) {
      if (this.skipToTag(tag, require) == false) {
        return def;
      }
  
      var head = this.readFrom();
      if (head.type != Taf.DataHelp.EN_LIST) {
        throw Error("read 'vector' type mismatch, tag: " + tag + ", get type: " + head.type);
      }
  
      var size = this.readInt32(0, true);
      if (size < 0) {
        throw Error("invalid size, tag: " + tag + ", type: " + head.type + ", size: " + size);
      }
      for (var i = 0; i < size; ++i) {
        def.value.push(def.proto._read(this, 0, def.proto._clone()));
      }
  
      return def;
    }
  
    Taf.JceInputStream.prototype.readMap = function (tag, require, def) {
      if (this.skipToTag(tag, require) == false) {
        return def;
      }
  
      var head = this.readFrom();
      if (head.type != Taf.DataHelp.EN_MAP) {
        throw Error("read 'map' type mismatch, tag: " + tag + ", get type: " + head.type);
      }
  
      var size = this.readInt32(0, true);
      if (size < 0) {
        throw Error("invalid map, tag: " + tag + ", size: " + size);
      }
  
      for (var i = 0; i < size; i++) {
        var key = def.kproto._read(this, 0, def.kproto._clone());
        var val = def.vproto._read(this, 1, def.vproto._clone());
        def.put(key, val);
      }
  
      return def;
    }
  
    /**
     * WUP使用类
     */
    Taf.Wup = function () {
      this.iVersion = 3;
      this.cPacketType = 0;
      this.iMessageType = 0;
      this.iRequestId = 0;
      this.sServantName = '';
      this.sFuncName = '';
      this.sBuffer = new Taf.BinBuffer();
      this.iTimeout = 0;
      this.context = new Taf.Map(new Taf.STRING(), new Taf.STRING());
      this.status = new Taf.Map(new Taf.STRING(), new Taf.STRING());
      this.newdata = new Taf.Map(new Taf.STRING(), new Taf.BinBuffer());
      this.iStream = new Taf.JceInputStream();
      this.oStream = new Taf.JceOutputStream();
    };
  
    Taf.Wup.prototype.hasKey = function (value) {
      return this.newdata.hasKey(value);
    }
  
    Taf.Wup.prototype.setVersion = function (value) {
      this.iVersion = value;
    }
  
    Taf.Wup.prototype.getVersion = function (value) {
      return this.iVersion;
    }
  
    Taf.Wup.prototype.setServant = function (value) {
      this.sServantName = value;
    };
  
    Taf.Wup.prototype.setFunc = function (value) {
      this.sFuncName = value;
    };
  
    Taf.Wup.prototype.setRequestId = function (value) {
      this.iRequestId = value ? value : (++this.iRequestId);
    };
  
    Taf.Wup.prototype.getRequestId = function () {
      return this.iRequestId;
    };
  
    Taf.Wup.prototype.setTimeOut = function (value) {
      this.iTimeout = value;
    };
  
    Taf.Wup.prototype.getTimeOut = function () {
      return this.iTimeout;
    };
  
    Taf.Wup.prototype.writeTo = function () {
      var os = this.oStream.clear();
      os.writeInt16(1, this.iVersion);
      os.writeInt8(2, this.cPacketType);
      os.writeInt32(3, this.iMessageType);
      os.writeInt32(4, this.iRequestId);
      os.writeString(5, this.sServantName);
      os.writeString(6, this.sFuncName);
      os.writeBytes(7, this.sBuffer);
      os.writeInt32(8, this.iTimeout);
      os.writeMap(9, this.context);
      os.writeMap(10, this.status);
      return new Taf.BinBuffer(os.getBuffer());
    };
  
    Taf.Wup.prototype.encode = function () {
      var os = this.oStream.clear();
      os.writeMap(0, this.newdata);
      this.sBuffer = os.getBinBuffer();
  
      var temp = this.writeTo();
      var buf = new Taf.BinBuffer();
      buf.writeInt32(4 + temp.len);
      buf.writeBytes(temp);
      return buf;
    }
  
    Taf.Wup.prototype.writeBoolean = function (name, value) {
      var os = this.oStream.clear();
      os.writeBoolean(0, value);
      this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    }
  
    Taf.Wup.prototype.writeInt8 = function (name, value) {
      var os = this.oStream.clear();
      os.writeInt8(0, value);
      this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    }
  
    Taf.Wup.prototype.writeInt16 = function (name, value) {
      var os = this.oStream.clear();
      os.writeInt16(0, value);
      this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    }
  
    Taf.Wup.prototype.writeInt32 = function (name, value) {
      var os = this.oStream.clear();
      os.writeInt32(0, value);
      this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    }
  
    Taf.Wup.prototype.writeInt64 = function (name, value) {
      var os = this.oStream.clear();
      os.writeInt64(0, value);
      this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    }
  
    Taf.Wup.prototype.writeFloat = function (name, value) {
      var os = this.oStream.clear();
      os.writeFloat(0, value);
      this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    }
  
    Taf.Wup.prototype.writeDouble = function (name, value) {
      var os = this.oStream.clear();
      os.writeDouble(0, value);
      this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    }
  
    Taf.Wup.prototype.writeString = function (name, value) {
      var os = this.oStream.clear();
      os.writeString(0, value);
      this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    }
  
    Taf.Wup.prototype.writeVector = function (name, value) {
      var os = this.oStream.clear();
      os.writeVector(0, value);
      this.newdata.put(name, new Taf.BinBuffer(os.getBinBuffer()));
    }
  
    Taf.Wup.prototype.writeStruct = function (name, value) {
      var os = this.oStream.clear();
      os.writeStruct(0, value);
      this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    }
  
    Taf.Wup.prototype.writeBytes = function (name, value) {
      var os = this.oStream.clear();
      os.writeBytes(0, value);
      this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    }
  
    Taf.Wup.prototype.writeMap = function (name, value) {
      var os = this.oStream.clear();
      os.writeMap(0, value);
      this.newdata.put(name, new Taf.BinBuffer(os.getBuffer()));
    }
  
    Taf.Wup.prototype.readFrom = function (is) {
      this.iVersion = is.readInt16(1, true);
      this.cPacketType = is.readInt8(2, true);
      this.iMessageType = is.readInt32(3, true);
      this.iRequestId = is.readInt32(4, true);
      this.sServantName = is.readString(5, true);
      this.sFuncName = is.readString(6, true);
  
      if (localStorage.__wup) {
        console.info('%c@@@ ' + this.sServantName + '.' + this.sFuncName, 'color:white;background:black;', this);
      }
  
      this.sBuffer = is.readBytes(7, true);
      this.iTimeout = is.readInt32(8, true);
      this.context = is.readMap(9, true, this.context);
      this.status = is.readMap(10, true, this.status);
    }
  
    Taf.Wup.prototype.decode = function (buf) {
      var is = this.iStream.setBuffer(buf);
      var len = is.buf.vew.getInt32(is.buf.position);
      if (len < 4) {
        throw Error("packet length too short");
      }
      // is.buf.length = len;
      is.buf.position += 4;
      this.readFrom(is);
      is = this.iStream.setBuffer(this.sBuffer.getBuffer());
      this.newdata.clear();
      is.readMap(0, true, this.newdata);
    }
  
    Taf.Wup.prototype.readBoolean = function (name) {
      var temp, def;
  
      temp = this.newdata.get(name);
      if (temp == undefined) {
        throw Error("UniAttribute not found key:" + name);
      }
      var is = this.iStream.setBuffer(temp.buffer);
      def = is.readBoolean(0, true, def);
  
      return def;
    }
  
    Taf.Wup.prototype.readInt8 = function (name) {
      var temp, def;
  
      temp = this.newdata.get(name);
      if (temp == undefined) {
        throw Error("UniAttribute not found key:" + name);
      }
      var is = this.iStream.setBuffer(temp.buffer);
      def = is.readInt8(0, true, def);
  
      return def;
    }
  
    Taf.Wup.prototype.readInt16 = function (name) {
      var temp, def;
  
      temp = this.newdata.get(name);
      if (temp == undefined) {
        throw Error("UniAttribute not found key:" + name);
      }
      var is = this.iStream.setBuffer(temp.buffer);
      def = is.readInt16(0, true, def);
  
      return def;
    }
  
    Taf.Wup.prototype.readInt32 = function (name) {
      var temp, def;
  
      temp = this.newdata.get(name);
      if (temp == undefined) {
        throw Error("UniAttribute not found key:" + name);
      }
      var is = this.iStream.setBuffer(temp.buffer);
      def = is.readInt32(0, true, def);
  
      return def;
    }
  
    Taf.Wup.prototype.readInt64 = function (name) {
      var temp, def;
  
      temp = this.newdata.get(name);
      if (temp == undefined) {
        throw Error("UniAttribute not found key:" + name);
      }
      var is = this.iStream.setBuffer(temp.buffer);
      def = is.readInt64(0, true, def);
  
      return def;
    }
  
    Taf.Wup.prototype.readFloat = function (name) {
      var temp, def;
  
      temp = this.newdata.get(name);
      if (temp == undefined) {
        throw Error("UniAttribute not found key:" + name);
      }
      var is = this.iStream.setBuffer(temp.buffer);
      def = is.readFloat(0, true, def);
  
      return def;
    }
  
    Taf.Wup.prototype.readDouble = function (name) {
      var temp;
  
      temp = this.newdata.get(name);
      if (temp == undefined) {
        throw Error("UniAttribute not found key:" + name);
      }
      var is = this.iStream.setBuffer(temp.buffer);
      def = is.readDouble(0, true, def);
  
      return def;
    }
  
    Taf.Wup.prototype.readVector = function (name, def, className) {
      var temp;
  
      temp = this.newdata.get(name);
      if (temp == undefined) {
        throw Error("UniAttribute not found key:" + name);
      }
      var is = this.iStream.setBuffer(temp.buffer);
      def = is.readVector(0, true, def);
  
      return def;
    }
  
    Taf.Wup.prototype.readStruct = function (name, def, className) {
      var temp;
  
      temp = this.newdata.get(name);
      if (temp == undefined) {
        throw Error("UniAttribute not found key:" + name);
      }
      var is = this.iStream.setBuffer(temp.buffer);
      def = is.readStruct(0, true, def);
  
      return def;
    }
  
    Taf.Wup.prototype.readMap = function (name, def, className) {
      var temp;
  
      temp = this.newdata.get(name);
      if (temp == undefined) {
        throw Error("UniAttribute not found key:" + name);
      }
      var is = this.iStream.setBuffer(temp.buffer);
      def = is.readMap(0, true, def);
  
      return def;
    }
  
    Taf.Wup.prototype.readBytes = function (name, def, className) {
      var temp;
  
      temp = this.newdata.get(name);
      if (temp == undefined) {
        throw Error("UniAttribute not found key:" + name);
      }
      var is = this.iStream.setBuffer(temp.buffer);
      def = is.readBytes(0, true, def);
  
      return def;
    }
  
    /**
     * 工具类
     */
    Taf.Util = Taf.Util || {};
  
    Taf.Util.jcestream = function (value, col) {
      if (value == null || value == undefined) {
        console.log("Taf.Util.jcestream::value is null or undefined");
        return;
      }
      if (!(value instanceof ArrayBuffer)) {
        console.log("Taf.Util.jcestream::value is not ArrayBuffer");
        return;
      }
      col = col || 16;
      var view = new Uint8Array(value);
      var str = "";
      for (var i = 0; i < view.length; i++) {
        if (i != 0 && i % col == 0) {
          str += "\n";
        } else if (i != 0) {
          str += " ";
        }
  
        str += (view[i] > 15 ? "" : "0") + view[i].toString(16);
      }
      console.log(str.toUpperCase());
    };
  
    Taf.Util.str2ab = function (value) {
      var idx, len = value.length,
        arr = new Array(len);
      for (idx = 0; idx < len; ++idx) {
        arr[idx] = value.charCodeAt(idx);
      }
  
      return new Uint8Array(arr).buffer;
    };
  
    Taf.Util.ajax = function (sURL, oData, oSuccFunc, oFailFunc) {
      var xmlobj = new XMLHttpRequest();
      xmlobj.overrideMimeType('text/plain; charset=x-user-defined'); //必须的&&一定要设置
  
      var handleStateChange = function () {
        if (xmlobj.readyState === 4) {
          if (xmlobj.status === 200 || xmlobj.status === 304) {
            oSuccFunc(Taf.Util.str2ab(xmlobj.response));
          } else {
            oFailFunc(xmlobj.status);
          }
  
          xmlobj.removeEventListener('readystatechange', handleStateChange);
          xmlobj = undefined;
        }
      };
  
      xmlobj.addEventListener('readystatechange', handleStateChange);
      xmlobj.open("post", sURL);
      xmlobj.send(oData);
    };;
  
    // 基础协议
    // **********************************************************************
    // This file was generated by a TAF parser!
    // TAF version 2.1.6.5
    // Generated from `GameLiveBase.jce'
    // **********************************************************************
    var HUYA = window.HUYA || {};
    window.HUYA = HUYA;
  
    HUYA.REDIS_CONNECT_FAIL = -100;
    HUYA.REDIS_COMMAND_FAIL = -101;
    HUYA.REDIS_RECORD_NOT_EXIST = -102;
    HUYA.UTSMD5KEY = "UI-TASK-USER,{8001EC79-E45F-4db7-9B82-9508463C3DCF}";
  
    HUYA.TemplateType = {
      PRIMARY: 1,
      RECEPTION: 2
    };
    HUYA.ELiveSource = {
      PC_YY: 0,
      PC_HUYA: 1,
      MOBILE_HUYA: 2,
      WEB_HUYA: 3
    };
  
    HUYA.EWebSocketCommandType = {
      EWSCmd_NULL: 0,
      EWSCmd_RegisterReq: 1,
      EWSCmd_RegisterRsp: 2,
      EWSCmd_WupReq: 3,
      EWSCmd_WupRsp: 4,
      EWSCmdC2S_HeartBeat: 5,
      EWSCmdS2C_HeartBeatAck: 6,
      EWSCmdS2C_MsgPushReq: 7,
      EWSCmdC2S_DeregisterReq: 8,
      EWSCmdS2C_DeRegisterRsp: 9,
      EWSCmdC2S_VerifyCookieReq: 10,
      EWSCmdS2C_VerifyCookieRsp: 11,
      EWSCmdC2S_VerifyHuyaTokenReq: 12,
      EWSCmdS2C_VerifyHuyaTokenRsp: 13,
      EWSCmdC2S_UNVerifyReq: 14,
      EWSCmdS2C_UNVerifyRsp: 15,
      EWSCmdC2S_RegisterGroupReq: 16,
      EWSCmdS2C_RegisterGroupRsp: 17,
      EWSCmdC2S_UnRegisterGroupReq: 18,
      EWSCmdS2C_UnRegisterGroupRsp: 19,
      EWSCmdC2S_HeartBeatReq: 20,
      EWSCmdS2C_HeartBeatRsp: 21,
      EWSCmdS2C_MsgPushReq_V2: 22
    };
  
    HUYA.SecPackType = {
      kSecPackTypeActivityMsgNotice: 1010003
    };
  
    HUYA.UserId = function () {
      this.lUid = 0;
      this.sGuid = "";
      this.sToken = "";
      this.sHuYaUA = "";
      this.sCookie = "";
      this.iTokenType = 0;
    };
    HUYA.UserId.prototype._clone = function () { return new HUYA.UserId(); }
    HUYA.UserId.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
    HUYA.UserId.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }
  
    HUYA.UserId.prototype.writeTo = function (os) {
      os.writeInt64(0, this.lUid);
      os.writeString(1, this.sGuid);
      os.writeString(2, this.sToken);
      os.writeString(3, this.sHuYaUA);
      os.writeString(4, this.sCookie);
      os.writeInt32(5, this.iTokenType);
    };
  
    HUYA.UserId.prototype.readFrom = function (is) {
      this.lUid = is.readInt64(0, false, this.lUid);
      this.sGuid = is.readString(1, false, this.sGuid);
      this.sToken = is.readString(2, false, this.sToken);
      this.sHuYaUA = is.readString(3, false, this.sHuYaUA);
      this.sCookie = is.readString(4, false, this.sCookie);
      this.iTokenType = is.readInt32(5, false, this.iTokenType);
    };
  
    HUYA.UserInfo = function () {
      this.lUid = 0;
      this.vHuyaB = new Taf.Vector(new Taf.INT32());
      this.iResignCard = 0;
      this.iExp = 0;
      this.iLevel = 0;
      this.iCurLevelExp = 0;
      this.iNextLevelExp = 0;
      this.iHuyaB = 0;
      this.iSignTaskStat = 0;
      this.iWatchLiveStat = 0;
      this.iLevelTaskStat = 0;
      this.vTaskStatus = new Taf.Vector(new HUYA.DailyTaskStatus());
    };
    HUYA.UserInfo.prototype._clone = function () {
      return new HUYA.UserInfo();
    }
    HUYA.UserInfo.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.UserInfo.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.UserInfo.prototype.writeTo = function (os) {
      os.writeInt64(0, this.lUid);
      os.writeVector(1, this.vHuyaB);
      os.writeInt32(2, this.iResignCard);
      os.writeInt32(3, this.iExp);
      os.writeInt32(4, this.iLevel);
      os.writeInt32(5, this.iCurLevelExp);
      os.writeInt32(6, this.iNextLevelExp);
      os.writeInt32(7, this.iHuyaB);
      os.writeInt32(8, this.iSignTaskStat);
      os.writeInt32(9, this.iWatchLiveStat);
      os.writeInt32(10, this.iLevelTaskStat);
      os.writeVector(11, this.vTaskStatus);
    };
  
    HUYA.UserInfo.prototype.readFrom = function (is) {
      this.lUid = is.readInt64(0, false, this.lUid);
      this.vHuyaB = is.readVector(1, false, this.vHuyaB);
      this.iResignCard = is.readInt32(2, false, this.iResignCard);
      this.iExp = is.readInt32(3, false, this.iExp);
      this.iLevel = is.readInt32(4, false, this.iLevel);
      this.iCurLevelExp = is.readInt32(5, false, this.iCurLevelExp);
      this.iNextLevelExp = is.readInt32(6, false, this.iNextLevelExp);
      this.iHuyaB = is.readInt32(7, false, this.iHuyaB);
      this.iSignTaskStat = is.readInt32(8, false, this.iSignTaskStat);
      this.iWatchLiveStat = is.readInt32(9, false, this.iWatchLiveStat);
      this.iLevelTaskStat = is.readInt32(10, false, this.iLevelTaskStat);
      this.vTaskStatus = is.readVector(11, false, this.vTaskStatus);
    };
  
    // WebSocket用户信息,login时封装
    HUYA.WSUserInfo = function () {
      this.lUid = 0;
      this.bAnonymous = true;
      this.sGuid = "";
      this.sToken = "";
      this.lTid = 0;
      this.lSid = 0;
      this.lGroupId = 0;
      this.lGroupType = 0;
      this.sAppId = "";
    };
    HUYA.WSUserInfo.prototype._clone = function () {
      return new HUYA.WSUserInfo();
    }
    HUYA.WSUserInfo.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.WSUserInfo.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.WSUserInfo.prototype.writeTo = function (os) {
      os.writeInt64(0, this.lUid);
      os.writeBoolean(1, this.bAnonymous);
      os.writeString(2, this.sGuid);
      os.writeString(3, this.sToken);
      os.writeInt64(4, this.lTid);
      os.writeInt64(5, this.lSid);
      os.writeInt64(6, this.lGroupId);
      os.writeInt64(7, this.lGroupType);
      os.writeString(8, this.sAppId);
    };
  
    HUYA.WSUserInfo.prototype.readFrom = function (is) {
      this.lUid = is.readInt64(0, false, this.lUid);
      this.bAnonymous = is.readBoolean(1, false, this.bAnonymous);
      this.sGuid = is.readString(2, false, this.sGuid);
      this.sToken = is.readString(3, false, this.sToken);
      this.lTid = is.readInt64(4, false, this.lTid);
      this.lSid = is.readInt64(5, false, this.lSid);
      this.lGroupId = is.readInt64(6, false, this.lGroupId);
      this.lGroupType = is.readInt64(7, false, this.lGroupType);
      this.sAppId = is.readString(8, false, this.sAppId);
    };
  
    HUYA.WSRegisterRsp = function () {
      this.iResCode = 0;
      this.lRequestId = 0;
      this.sMessage = "";
      this.sBCConnHost = "";
    };
    HUYA.WSRegisterRsp.prototype._clone = function () {
      return new HUYA.WSRegisterRsp();
    }
    HUYA.WSRegisterRsp.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.WSRegisterRsp.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.WSRegisterRsp.prototype.writeTo = function (os) {
      os.writeInt32(0, this.iResCode);
      os.writeInt64(1, this.lRequestId);
      os.writeString(2, this.sMessage);
      os.writeString(3, this.sBCConnHost);
    };
  
    HUYA.WSRegisterRsp.prototype.readFrom = function (is) {
      this.iResCode = is.readInt32(0, false, this.iResCode);
      this.lRequestId = is.readInt64(1, false, this.lRequestId);
      this.sMessage = is.readString(2, false, this.sMessage);
      this.sBCConnHost = is.readString(3, false, this.sBCConnHost);
    };
  
    // WebScoket命令结构
    HUYA.WebSocketCommand = function () {
      this.iCmdType = 0;
      this.vData = new Taf.BinBuffer();
      this.lRequestId = 0;
      this.traceId = "";
    };
    HUYA.WebSocketCommand.prototype._clone = function () { return new HUYA.WebSocketCommand(); }
    HUYA.WebSocketCommand.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
    HUYA.WebSocketCommand.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }
  
    HUYA.WebSocketCommand.prototype.writeTo = function (os) {
      os.writeInt32(0, this.iCmdType);
      os.writeBytes(1, this.vData);
      os.writeInt64(2, this.lRequestId);
      os.writeString(3, this.traceId);
    };
  
    HUYA.WebSocketCommand.prototype.readFrom = function (is) {
      this.iCmdType = is.readInt32(0, false, this.iCmdType);
      this.vData = is.readBytes(1, false, this.vData);
      this.lRequestId = is.readInt64(2, false, this.lRequestId);
      this.traceId = is.readString(3, false, this.traceId);
    };
  
  
    // websocket推送消息结构  根据uri对应具体推送结构
    HUYA.WSPushMessage = function () {
      this.ePushType = 0;
      this.iUri = 0;
      this.sMsg = new Taf.BinBuffer();
      this.iProtocolType = 0;
      this.sGroupId = "";
      this.lMsgId = 0;
    };
    HUYA.WSPushMessage.prototype._clone = function () {
      return new HUYA.WSPushMessage();
    }
    HUYA.WSPushMessage.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.WSPushMessage.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.WSPushMessage.prototype.writeTo = function (os) {
      os.writeInt32(0, this.ePushType);
      os.writeInt64(1, this.iUri);
      os.writeBytes(2, this.sMsg);
      os.writeInt32(3, this.iProtocolType);
      os.writeString(4, this.sGroupId);
      os.writeInt64(5, this.lMsgId);
    };
  
    HUYA.WSPushMessage.prototype.readFrom = function (is) {
      this.ePushType = is.readInt32(0, false, this.ePushType);
      this.iUri = is.readInt64(1, false, this.iUri);
      this.sMsg = is.readBytes(2, false, this.sMsg);
      this.iProtocolType = is.readInt32(3, false, this.iProtocolType);
      this.sGroupId = is.readString(4, false, this.sGroupId);
      this.lMsgId = is.readInt64(5, false, this.lMsgId);
    };
  
  
    // websocket心跳命令体
    HUYA.WSHeartBeat = function () {
      this.iState = 0;
    };
    HUYA.WSHeartBeat.prototype._clone = function () {
      return new HUYA.WSHeartBeat();
    }
    HUYA.WSHeartBeat.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.WSHeartBeat.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.WSHeartBeat.prototype.writeTo = function (os) {
      os.writeInt32(0, this.iState);
    };
  
    HUYA.WSHeartBeat.prototype.readFrom = function (is) {
      this.iState = is.readInt32(0, false, this.iState);
    };
  
  
    // 服务器生成的唯一id信息，请求时携带，标志唯一一台终端
    // 当前服务器时间
  
    HUYA.LiveAppUAEx = function () {
      this.sIMEI = "";
      this.sAPN = "";
      this.sNetType = "";
    };
    HUYA.LiveAppUAEx.prototype._clone = function () {
      return new HUYA.LiveAppUAEx();
    }
    HUYA.LiveAppUAEx.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.LiveAppUAEx.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.LiveAppUAEx.prototype.writeTo = function (os) {
      os.writeString(1, this.sIMEI);
      os.writeString(2, this.sAPN);
      os.writeString(3, this.sNetType);
    };
  
    HUYA.LiveAppUAEx.prototype.readFrom = function (is) {
      this.sIMEI = is.readString(1, false, this.sIMEI);
      this.sAPN = is.readString(2, false, this.sAPN);
      this.sNetType = is.readString(3, false, this.sNetType);
    };
  
  
    HUYA.LiveUserbase = function () {
      this.eSource = 0;
      this.eType = 0;
      this.tUAEx = new HUYA.LiveAppUAEx();
    };
    HUYA.LiveUserbase.prototype._clone = function () {
      return new HUYA.LiveUserbase();
    }
    HUYA.LiveUserbase.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.LiveUserbase.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.LiveUserbase.prototype.writeTo = function (os) {
      os.writeInt32(0, this.eSource);
      os.writeInt32(1, this.eType);
      os.writeStruct(2, this.tUAEx);
    };
  
    HUYA.LiveUserbase.prototype.readFrom = function (is) {
      this.eSource = is.readInt32(0, false, this.eSource);
      this.eType = is.readInt32(1, false, this.eType);
      this.tUAEx = is.readStruct(2, false, this.tUAEx);
    };
  
  
    HUYA.LiveLaunchReq = function () {
      this.tId = new HUYA.UserId();
      this.tLiveUB = new HUYA.LiveUserbase();
      this.bSupportDomain = 0;
    };
    HUYA.LiveLaunchReq.prototype._clone = function () {
      return new HUYA.LiveLaunchReq();
    }
    HUYA.LiveLaunchReq.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.LiveLaunchReq.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.LiveLaunchReq.prototype.writeTo = function (os) {
      os.writeStruct(0, this.tId);
      os.writeStruct(1, this.tLiveUB);
      os.writeInt32(2, this.bSupportDomain);
    };
  
    HUYA.LiveLaunchReq.prototype.readFrom = function (is) {
      this.tId = is.readStruct(0, false, this.tId);
      this.tLiveUB = is.readStruct(1, false, this.tLiveUB);
      this.bSupportDomain = is.readInt32(2, false, this.bSupportDomain);
    };
  
    HUYA.LiveProxyValue = function () {
      this.eProxyType = 0;
      this.sProxy = new Taf.Vector(new Taf.STRING());
    };
    HUYA.LiveProxyValue.prototype._clone = function () {
      return new HUYA.LiveProxyValue();
    }
    HUYA.LiveProxyValue.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.LiveProxyValue.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.LiveProxyValue.prototype.writeTo = function (os) {
      os.writeInt32(0, this.eProxyType);
      os.writeVector(1, this.sProxy);
    };
  
    HUYA.LiveProxyValue.prototype.readFrom = function (is) {
      this.eProxyType = is.readInt32(0, false, this.eProxyType);
      this.sProxy = is.readVector(1, false, this.sProxy);
    };
  
    HUYA.LiveLaunchRsp = function () {
      this.sGuid = "";
      this.iTime = 0;
      this.vProxyList = new Taf.Vector(new HUYA.LiveProxyValue());
      this.eAccess = 0;
      this.sClientIp = "";
    };
    HUYA.LiveLaunchRsp.prototype._clone = function () {
      return new HUYA.LiveLaunchRsp();
    }
    HUYA.LiveLaunchRsp.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.LiveLaunchRsp.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.LiveLaunchRsp.prototype.writeTo = function (os) {
      os.writeString(0, this.sGuid);
      os.writeInt32(1, this.iTime);
      os.writeVector(2, this.vProxyList);
      os.writeInt32(3, this.eAccess);
      os.writeString(4, this.sClientIp);
    };
  
    HUYA.LiveLaunchRsp.prototype.readFrom = function (is) {
      this.sGuid = is.readString(0, false, this.sGuid);
      this.iTime = is.readInt32(1, false, this.iTime);
      this.vProxyList = is.readVector(2, false, this.vProxyList);
      this.eAccess = is.readInt32(3, false, this.eAccess);
      this.sClientIp = is.readString(4, false, this.sClientIp);
    };
  
  
    // web端ip登录校验cookie请求
    HUYA.WSVerifyCookieReq = function () {
      this.lUid = 0;
      this.sUA = "";
      this.sCookie = "";
    };
    HUYA.WSVerifyCookieReq.prototype._clone = function () {
      return new HUYA.WSVerifyCookieReq();
    }
    HUYA.WSVerifyCookieReq.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.WSVerifyCookieReq.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.WSVerifyCookieReq.prototype.writeTo = function (os) {
      os.writeInt64(0, this.lUid);
      os.writeString(1, this.sUA);
      os.writeString(2, this.sCookie);
    };
  
    HUYA.WSVerifyCookieReq.prototype.readFrom = function (is) {
      this.lUid = is.readInt64(0, false, this.lUid);
      this.sUA = is.readString(1, false, this.sUA);
      this.sCookie = is.readString(2, false, this.sCookie);
    };
  
    // web端ip登录校验cookie应答
    HUYA.WSVerifyCookieRsp = function () {
      this.iValidate = 0;
    };
    HUYA.WSVerifyCookieRsp.prototype._clone = function () {
      return new HUYA.WSVerifyCookieRsp();
    }
    HUYA.WSVerifyCookieRsp.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.WSVerifyCookieRsp.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.WSVerifyCookieRsp.prototype.writeTo = function (os) {
      os.writeInt32(0, this.iValidate);
    };
  
    HUYA.WSVerifyCookieRsp.prototype.readFrom = function (is) {
      this.iValidate = is.readInt32(0, false, this.iValidate);
    };
  
    HUYA.WSPushMessage_V2 = function () {
      this.sGroupId = "";
      this.vMsgItem = new Taf.Vector(new HUYA.WSMsgItem());
    };
    HUYA.WSPushMessage_V2.prototype._clone = function () { return new HUYA.WSPushMessage_V2(); }
    HUYA.WSPushMessage_V2.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
    HUYA.WSPushMessage_V2.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }
  
    HUYA.WSPushMessage_V2.prototype.writeTo = function (os) {
      os.writeString(0, this.sGroupId);
      os.writeVector(1, this.vMsgItem);
    };
  
    HUYA.WSPushMessage_V2.prototype.readFrom = function (is) {
      this.sGroupId = is.readString(0, false, this.sGroupId);
      this.vMsgItem = is.readVector(1, false, this.vMsgItem);
    };
    HUYA.WSRegisterGroupReq = function () {
      this.vGroupId = new Taf.Vector(new Taf.STRING());
      this.sToken = "";
    };
    HUYA.WSRegisterGroupReq.prototype._clone = function () { return new HUYA.WSRegisterGroupReq(); }
    HUYA.WSRegisterGroupReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
    HUYA.WSRegisterGroupReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }
  
    HUYA.WSRegisterGroupReq.prototype.writeTo = function (os) {
      os.writeVector(0, this.vGroupId);
      os.writeString(1, this.sToken);
    };
  
    HUYA.WSRegisterGroupReq.prototype.readFrom = function (is) {
      this.vGroupId = is.readVector(0, false, this.vGroupId);
      this.sToken = is.readString(1, false, this.sToken);
    };
    HUYA.WSRegisterGroupRsp = function () {
      this.iResCode = 0;
    };
    HUYA.WSRegisterGroupRsp.prototype._clone = function () { return new HUYA.WSRegisterGroupRsp(); }
    HUYA.WSRegisterGroupRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
    HUYA.WSRegisterGroupRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }
  
    HUYA.WSRegisterGroupRsp.prototype.writeTo = function (os) {
      os.writeInt32(0, this.iResCode);
    };
  
    HUYA.WSRegisterGroupRsp.prototype.readFrom = function (is) {
      this.iResCode = is.readInt32(0, false, this.iResCode);
    };
    HUYA.WSUnRegisterGroupReq = function () {
      this.vGroupId = new Taf.Vector(new Taf.STRING());
    };
    HUYA.WSUnRegisterGroupReq.prototype._clone = function () { return new HUYA.WSUnRegisterGroupReq(); }
    HUYA.WSUnRegisterGroupReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
    HUYA.WSUnRegisterGroupReq.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }
  
    HUYA.WSUnRegisterGroupReq.prototype.writeTo = function (os) {
      os.writeVector(0, this.vGroupId);
    };
  
    HUYA.WSUnRegisterGroupReq.prototype.readFrom = function (is) {
      this.vGroupId = is.readVector(0, false, this.vGroupId);
    };
    HUYA.WSUnRegisterGroupRsp = function () {
      this.iResCode = 0;
    };
    HUYA.WSUnRegisterGroupRsp.prototype._clone = function () { return new HUYA.WSUnRegisterGroupRsp(); }
    HUYA.WSUnRegisterGroupRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
    HUYA.WSUnRegisterGroupRsp.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }
  
    HUYA.WSUnRegisterGroupRsp.prototype.writeTo = function (os) {
      os.writeInt32(0, this.iResCode);
    };
  
    HUYA.WSUnRegisterGroupRsp.prototype.readFrom = function (is) {
      this.iResCode = is.readInt32(0, false, this.iResCode);
    };
  
    HUYA.WSMsgItem = function () {
      this.iUri = 0;
      this.sMsg = new Taf.BinBuffer();
      this.lMsgId = 0;
    };
    HUYA.WSMsgItem.prototype._clone = function () { return new HUYA.WSMsgItem(); }
    HUYA.WSMsgItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
    HUYA.WSMsgItem.prototype._read = function (is, tag, def) { return is.readStruct(tag, true, def); }
  
    HUYA.WSMsgItem.prototype.writeTo = function (os) {
      os.writeInt64(0, this.iUri);
      os.writeBytes(1, this.sMsg);
      os.writeInt64(2, this.lMsgId);
    };
  
    HUYA.WSMsgItem.prototype.readFrom = function (is) {
      this.iUri = is.readInt64(0, false, this.iUri);
      this.sMsg = is.readBytes(1, false, this.sMsg);
      this.lMsgId = is.readInt64(2, false, this.lMsgId);
    };
    // 供客户端onClientReady和服务器的EnterChannel使用
    HUYA.EnterChannelReq = function () {
      this.tUserId = new HUYA.UserId();
      this.lTid = 0;
      this.lSid = 0;
      this.iChannelType = 0;
    };
    HUYA.EnterChannelReq.prototype._clone = function () {
      return new HUYA.EnterChannelReq();
    }
    HUYA.EnterChannelReq.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.EnterChannelReq.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.EnterChannelReq.prototype.writeTo = function (os) {
      os.writeStruct(1, this.tUserId);
      os.writeInt64(2, this.lTid);
      os.writeInt64(3, this.lSid);
      os.writeInt32(4, this.iChannelType);
    };
  
    HUYA.EnterChannelReq.prototype.readFrom = function (is) {
      this.tUserId = is.readStruct(1, false, this.tUserId);
      this.lTid = is.readInt64(2, false, this.lTid);
      this.lSid = is.readInt64(3, false, this.lSid);
      this.iChannelType = is.readInt32(4, false, this.iChannelType);
    };
  
  
    //活动
    // 活动拉取回调
    HUYA.ActivityMsgReq = function () {
      this.tUserId = new HUYA.UserId();
      this.iActivityId = 0;
      this.lPid = 0;
      this.lTid = 0;
      this.lSid = 0;
      this.iChannelType = 0;
      this.iSubUri = 0;
    };
    HUYA.ActivityMsgReq.prototype._clone = function () {
      return new HUYA.ActivityMsgReq();
    }
    HUYA.ActivityMsgReq.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.ActivityMsgReq.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.ActivityMsgReq.prototype.writeTo = function (os) {
      os.writeStruct(0, this.tUserId);
      os.writeInt32(1, this.iActivityId);
      os.writeInt64(2, this.lPid);
      os.writeInt64(3, this.lTid);
      os.writeInt64(4, this.lSid);
      os.writeInt32(5, this.iChannelType);
      os.writeInt32(6, this.iSubUri);
    };
  
    HUYA.ActivityMsgReq.prototype.readFrom = function (is) {
      this.tUserId = is.readStruct(0, false, this.tUserId);
      this.iActivityId = is.readInt32(1, false, this.iActivityId);
      this.lPid = is.readInt64(2, false, this.lPid);
      this.lTid = is.readInt64(3, false, this.lTid);
      this.lSid = is.readInt64(4, false, this.lSid);
      this.iChannelType = is.readInt32(5, false, this.iChannelType);
      this.iSubUri = is.readInt32(6, false, this.iSubUri);
    };
  
  
    HUYA.ActivitySerializedMsg = function () {
      this.iSubUri = 0;
      this.vContent = new Taf.BinBuffer();
    };
    HUYA.ActivitySerializedMsg.prototype._clone = function () {
      return new HUYA.ActivitySerializedMsg();
    }
    HUYA.ActivitySerializedMsg.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.ActivitySerializedMsg.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.ActivitySerializedMsg.prototype.writeTo = function (os) {
      os.writeInt32(0, this.iSubUri);
      os.writeBytes(1, this.vContent);
    };
  
    HUYA.ActivitySerializedMsg.prototype.readFrom = function (is) {
      this.iSubUri = is.readInt32(0, false, this.iSubUri);
      this.vContent = is.readBytes(1, false, this.vContent);
    };
  
    HUYA.ActivityMsgRsp = function () {
      this.iEnable = 0;
      this.vSerializedMsg = new Taf.Vector(new HUYA.ActivitySerializedMsg());
      this.iTimeStamp = 0;
    };
    HUYA.ActivityMsgRsp.prototype._clone = function () {
      return new HUYA.ActivityMsgRsp();
    }
    HUYA.ActivityMsgRsp.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.ActivityMsgRsp.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.ActivityMsgRsp.prototype.writeTo = function (os) {
      os.writeInt32(0, this.iEnable);
      os.writeVector(1, this.vSerializedMsg);
      os.writeInt32(2, this.iTimeStamp);
    };
  
    HUYA.ActivityMsgRsp.prototype.readFrom = function (is) {
      this.iEnable = is.readInt32(0, false, this.iEnable);
      this.vSerializedMsg = is.readVector(1, false, this.vSerializedMsg);
      this.iTimeStamp = is.readInt32(2, false, this.iTimeStamp);
    };
  
    HUYA.PresenterChannelInfo = function () {
      this.lYYId = 0;
      this.lTid = 0;
      this.lSid = 0;
      this.iSourceType = 0;
      this.iScreenType = 0;
      this.lUid = 0;
      this.iGameId = 0;
    };
    HUYA.PresenterChannelInfo.prototype._clone = function () {
      return new HUYA.PresenterChannelInfo();
    }
    HUYA.PresenterChannelInfo.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.PresenterChannelInfo.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.PresenterChannelInfo.prototype.writeTo = function (os) {
      os.writeInt64(0, this.lYYId);
      os.writeInt64(1, this.lTid);
      os.writeInt64(3, this.lSid);
      os.writeInt32(4, this.iSourceType);
      os.writeInt32(5, this.iScreenType);
      os.writeInt64(6, this.lUid);
      os.writeInt32(7, this.iGameId);
    };
  
    HUYA.PresenterChannelInfo.prototype.readFrom = function (is) {
      this.lYYId = is.readInt64(0, false, this.lYYId);
      this.lTid = is.readInt64(1, false, this.lTid);
      this.lSid = is.readInt64(3, false, this.lSid);
      this.iSourceType = is.readInt32(4, false, this.iSourceType);
      this.iScreenType = is.readInt32(5, false, this.iScreenType);
      this.lUid = is.readInt64(6, false, this.lUid);
      this.iGameId = is.readInt32(7, false, this.iGameId);
    };
  
    HUYA.BadgeReq = function () {
      this.tUserId = new HUYA.UserId();
      this.lBadgeId = 0;
      this.lToUid = 0;
    };
    HUYA.BadgeReq.prototype._clone = function () {
      return new HUYA.BadgeReq();
    }
    HUYA.BadgeReq.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.BadgeReq.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.BadgeReq.prototype.writeTo = function (os) {
      os.writeStruct(0, this.tUserId);
      os.writeInt64(1, this.lBadgeId);
      os.writeInt64(2, this.lToUid);
    };
  
    HUYA.BadgeReq.prototype.readFrom = function (is) {
      this.tUserId = is.readStruct(0, false, this.tUserId);
      this.lBadgeId = is.readInt64(1, false, this.lBadgeId);
      this.lToUid = is.readInt64(2, false, this.lToUid);
    };
  
    HUYA.BadgeInfo = function () {
      this.lUid = 0;
      this.lBadgeId = 0;
      this.sPresenterNickName = "";
      this.sBadgeName = "";
      this.iBadgeLevel = 0;
      this.iRank = 0;
      this.iScore = 0;
      this.iNextScore = 0;
      this.iQuotaUsed = 0;
      this.iQuota = 0;
      this.lQuotaTS = 0;
      this.lOpenTS = 0;
      this.iVFlag = 0;
      this.sVLogo = "";
      this.tChannelInfo = new HUYA.PresenterChannelInfo();
      this.sPresenterLogo = "";
      this.lVExpiredTS = 0;
    };
    HUYA.BadgeInfo.prototype._clone = function () {
      return new HUYA.BadgeInfo();
    }
    HUYA.BadgeInfo.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.BadgeInfo.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.BadgeInfo.prototype.writeTo = function (os) {
      os.writeInt64(0, this.lUid);
      os.writeInt64(1, this.lBadgeId);
      os.writeString(2, this.sPresenterNickName);
      os.writeString(3, this.sBadgeName);
      os.writeInt32(4, this.iBadgeLevel);
      os.writeInt32(5, this.iRank);
      os.writeInt32(6, this.iScore);
      os.writeInt32(7, this.iNextScore);
      os.writeInt32(8, this.iQuotaUsed);
      os.writeInt32(9, this.iQuota);
      os.writeInt64(10, this.lQuotaTS);
      os.writeInt64(11, this.lOpenTS);
      os.writeInt32(12, this.iVFlag);
      os.writeString(13, this.sVLogo);
      os.writeStruct(14, this.tChannelInfo);
      os.writeString(15, this.sPresenterLogo);
      os.writeInt64(16, this.lVExpiredTS);
    };
  
    HUYA.BadgeInfo.prototype.readFrom = function (is) {
      this.lUid = is.readInt64(0, false, this.lUid);
      this.lBadgeId = is.readInt64(1, false, this.lBadgeId);
      this.sPresenterNickName = is.readString(2, false, this.sPresenterNickName);
      this.sBadgeName = is.readString(3, false, this.sBadgeName);
      this.iBadgeLevel = is.readInt32(4, false, this.iBadgeLevel);
      this.iRank = is.readInt32(5, false, this.iRank);
      this.iScore = is.readInt32(6, false, this.iScore);
      this.iNextScore = is.readInt32(7, false, this.iNextScore);
      this.iQuotaUsed = is.readInt32(8, false, this.iQuotaUsed);
      this.iQuota = is.readInt32(9, false, this.iQuota);
      this.lQuotaTS = is.readInt64(10, false, this.lQuotaTS);
      this.lOpenTS = is.readInt64(11, false, this.lOpenTS);
      this.iVFlag = is.readInt32(12, false, this.iVFlag);
      this.sVLogo = is.readString(13, false, this.sVLogo);
      this.tChannelInfo = is.readStruct(14, false, this.tChannelInfo);
      this.sPresenterLogo = is.readString(15, false, this.sPresenterLogo);
      this.lVExpiredTS = is.readInt64(16, false, this.lVExpiredTS);
    };
  
    HUYA.SendCardPackageItemReq = function () {
      this.tId = new HUYA.UserId();
      this.lSid = 0;
      this.lSubSid = 0;
      this.iShowFreeitemInfo = 0;
      this.iItemType = 0;
      this.iItemCount = 0;
      this.lPresenterUid = 0;
      this.sPayId = "";
      this.sSendContent = "";
      this.sSenderNick = "";
      this.sPresenterNick = "";
      this.iPayPloy = 0;
      this.iItemCountByGroup = 0;
      this.iItemGroup = 0;
      this.iSuperPupleLevel = 0;
      this.iFromType = 0;
      this.sExpand = "";
      this.sToken = "";
      this.iTemplateType = 0;
      this.sTokencaKey = "";
      this.sPassport = "";
      this.iSenderShortSid = 0;
      this.iPayByFreeItem = 0;
      this.tExtUser = new HUYA.ExternalUser();
      this.iEventType = 0;
    };
    HUYA.SendCardPackageItemReq.prototype._clone = function () {
      return new HUYA.SendCardPackageItemReq();
    }
    HUYA.SendCardPackageItemReq.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.SendCardPackageItemReq.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.SendCardPackageItemReq.prototype.writeTo = function (os) {
      os.writeStruct(0, this.tId);
      os.writeInt64(1, this.lSid);
      os.writeInt64(2, this.lSubSid);
      os.writeInt32(3, this.iShowFreeitemInfo);
      os.writeInt32(4, this.iItemType);
      os.writeInt32(5, this.iItemCount);
      os.writeInt64(6, this.lPresenterUid);
      os.writeString(7, this.sPayId);
      os.writeString(9, this.sSendContent);
      os.writeString(10, this.sSenderNick);
      os.writeString(11, this.sPresenterNick);
      os.writeInt32(12, this.iPayPloy);
      os.writeInt32(13, this.iItemCountByGroup);
      os.writeInt32(14, this.iItemGroup);
      os.writeInt32(15, this.iSuperPupleLevel);
      os.writeInt32(16, this.iFromType);
      os.writeString(17, this.sExpand);
      os.writeString(18, this.sToken);
      os.writeInt32(19, this.iTemplateType);
      os.writeString(20, this.sTokencaKey);
      os.writeString(21, this.sPassport);
      os.writeInt64(22, this.iSenderShortSid);
      os.writeInt32(23, this.iPayByFreeItem);
      os.writeStruct(24, this.tExtUser);
      os.writeInt16(25, this.iEventType);
    };
  
    HUYA.SendCardPackageItemReq.prototype.readFrom = function (is) {
      this.tId = is.readStruct(0, false, this.tId);
      this.lSid = is.readInt64(1, false, this.lSid);
      this.lSubSid = is.readInt64(2, false, this.lSubSid);
      this.iShowFreeitemInfo = is.readInt32(3, false, this.iShowFreeitemInfo);
      this.iItemType = is.readInt32(4, false, this.iItemType);
      this.iItemCount = is.readInt32(5, false, this.iItemCount);
      this.lPresenterUid = is.readInt64(6, false, this.lPresenterUid);
      this.sPayId = is.readString(7, false, this.sPayId);
      this.sSendContent = is.readString(9, false, this.sSendContent);
      this.sSenderNick = is.readString(10, false, this.sSenderNick);
      this.sPresenterNick = is.readString(11, false, this.sPresenterNick);
      this.iPayPloy = is.readInt32(12, false, this.iPayPloy);
      this.iItemCountByGroup = is.readInt32(13, false, this.iItemCountByGroup);
      this.iItemGroup = is.readInt32(14, false, this.iItemGroup);
      this.iSuperPupleLevel = is.readInt32(15, false, this.iSuperPupleLevel);
      this.iFromType = is.readInt32(16, false, this.iFromType);
      this.sExpand = is.readString(17, false, this.sExpand);
      this.sToken = is.readString(18, false, this.sToken);
      this.iTemplateType = is.readInt32(19, false, this.iTemplateType);
      this.sTokencaKey = is.readString(20, false, this.sTokencaKey);
      this.sPassport = is.readString(21, false, this.sPassport);
      this.iSenderShortSid = is.readInt64(22, false, this.iSenderShortSid);
      this.iPayByFreeItem = is.readInt32(23, false, this.iPayByFreeItem);
      this.tExtUser = is.readStruct(24, false, this.tExtUser);
      this.iEventType = is.readInt16(25, false, this.iEventType);
    };
  
    HUYA.SendCardPackageItemRsp = function () {
      this.iPayRespCode = 0;
      this.iItemType = 0;
      this.iItemCount = 0;
      this.strPayId = "";
      this.strPayConfirmUrl = "";
      this.strSendContent = "";
      this.iItemCountByGroup = 0;
      this.iItemGroup = 0;
      this.lPresenterUid = 0;
      this.sExpand = "";
      this.strPayItemInfo = "";
      this.iPayType = 0;
    };
    HUYA.SendCardPackageItemRsp.prototype._clone = function () {
      return new HUYA.SendCardPackageItemRsp();
    }
    HUYA.SendCardPackageItemRsp.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.SendCardPackageItemRsp.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.SendCardPackageItemRsp.prototype.writeTo = function (os) {
      os.writeInt32(0, this.iPayRespCode);
      os.writeInt32(1, this.iItemType);
      os.writeInt32(2, this.iItemCount);
      os.writeString(3, this.strPayId);
      os.writeString(4, this.strPayConfirmUrl);
      os.writeString(5, this.strSendContent);
      os.writeInt32(6, this.iItemCountByGroup);
      os.writeInt32(7, this.iItemGroup);
      os.writeInt64(8, this.lPresenterUid);
      os.writeString(9, this.sExpand);
      os.writeString(10, this.strPayItemInfo);
      os.writeInt32(11, this.iPayType);
    };
  
    HUYA.SendCardPackageItemRsp.prototype.readFrom = function (is) {
      this.iPayRespCode = is.readInt32(0, false, this.iPayRespCode);
      this.iItemType = is.readInt32(1, false, this.iItemType);
      this.iItemCount = is.readInt32(2, false, this.iItemCount);
      this.strPayId = is.readString(3, false, this.strPayId);
      this.strPayConfirmUrl = is.readString(4, false, this.strPayConfirmUrl);
      this.strSendContent = is.readString(5, false, this.strSendContent);
      this.iItemCountByGroup = is.readInt32(6, false, this.iItemCountByGroup);
      this.iItemGroup = is.readInt32(7, false, this.iItemGroup);
      this.lPresenterUid = is.readInt64(8, false, this.lPresenterUid);
      this.sExpand = is.readString(9, false, this.sExpand);
      this.strPayItemInfo = is.readString(10, false, this.strPayItemInfo);
      this.iPayType = is.readInt32(11, false, this.iPayType);
    };
  
    HUYA.ExternalUser = function () {
      this.sId = "";
      this.sToken = "";
      this.sOther = "";
    };
    HUYA.ExternalUser.prototype._clone = function () {
      return new HUYA.ExternalUser();
    }
    HUYA.ExternalUser.prototype._write = function (os, tag, value) {
      os.writeStruct(tag, value);
    }
    HUYA.ExternalUser.prototype._read = function (is, tag, def) {
      return is.readStruct(tag, true, def);
    }
  
    HUYA.ExternalUser.prototype.writeTo = function (os) {
      os.writeString(0, this.sId);
      os.writeString(1, this.sToken);
      os.writeString(2, this.sOther);
    };
  
    HUYA.ExternalUser.prototype.readFrom = function (is) {
      this.sId = is.readString(0, false, this.sId);
      this.sToken = is.readString(1, false, this.sToken);
      this.sOther = is.readString(2, false, this.sOther);
    };
  
    function isIOS() {
      var browser = {
        versions: function () {
          var u = navigator.userAgent;
          return { //移动终端浏览器版本信息 
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端 
          };
        }()
      };
  
      return !!browser.versions.ios;
    }
  
    function getURLParam(name) {
      var value = window.location.search.match(new RegExp("[?&]" + name + "=([^&]*)(&?)", "i"));
      return value ? decodeURIComponent(value[1]) : value;
    }
  
    //随机打乱数组
    function mess(arr) {
      var _floor = Math.floor,
        _random = Math.random,
        len = arr.length,
        i, j, arri,
        n = _floor(len / 2) + 1;
      while (n--) {
        i = _floor(_random() * len);
        j = _floor(_random() * len);
        if (i !== j) {
          arri = arr[i];
          arr[i] = arr[j];
          arr[j] = arri;
        }
      }
      return arr;
    }
  
    function logcss(color) {
      return "color:" + color + ";font-weight:900";
    };
  
    function versionfunegt(ver1, ver2) {
      //将ver1转换成'*.0*.*'，即中间不足两位的补0处理
      var ver1Arr = ver1 && ver1.split('.');
      var midStr = ver1Arr[1] && (parseInt(ver1Arr[1]) < 10 ? ('0' + ver1Arr[1]) : ver1Arr[1]);
      var ver1Formated = ver1Arr[0] + '.' + midStr + '.' + ver1Arr[2];
  
      var version1next = parseInt(ver1Formated.replace(/\./g, ""));
      var version2next = parseInt(ver2.replace(/\./g, ""));
  
      if (version1next >= version2next) {
        return true;
      } else {
        return false;
      }
    }
  
    //设置全局变量
    window.ISDEBUG = true;
    window.LINK_TIME_START = 0;//连接开始的时间
    window.LINK_TIME_ON = 0;//连接上的时间
  
    /**
    ** metricData: {}
    **/
    function perfermanceReport(metricData) {
      var schema = 'http';
      if (window.location.protocol === 'https:') {
        schema = 'https';
      }
  
      // var server = window.ISDEBUG ? '//116.31.112.109:8080/?' : '//metric.huya.com/?';
      var server = '//metric.huya.com/?';
  
      function getCookieVal(cookieName) {
        var arrstr = document.cookie.split("; ");
        for (var i = 0; i < arrstr.length; i = i + 1) {
          var kv = arrstr[i].split("=");
          if (kv[0] == cookieName) return decodeURIComponent(kv[1]);
        }
        return "";
      }
  
  
      var platform = (function () {
        var u = navigator.userAgent;
        var device = 'web';
        if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
          device = 'android';
          return device;
        }
        if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
          device = 'ios';
          return device;
        }
        return device;
      })();
  
      var Base64 = {
        _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  
        encode: function (input) {
          var output = "";
          var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
          var i = 0;
  
          input = Base64._utf8_encode(input);
  
          while (i < input.length) {
  
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);
  
            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;
  
            if (isNaN(chr2)) {
              enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
              enc4 = 64;
            }
  
            output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
  
          }
  
          return output;
        },
  
  
        decode: function (input) {
          var output = "";
          var chr1, chr2, chr3;
          var enc1, enc2, enc3, enc4;
          var i = 0;
  
          input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  
          while (i < input.length) {
  
            enc1 = this._keyStr.indexOf(input.charAt(i++));
            enc2 = this._keyStr.indexOf(input.charAt(i++));
            enc3 = this._keyStr.indexOf(input.charAt(i++));
            enc4 = this._keyStr.indexOf(input.charAt(i++));
  
            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;
  
            output = output + String.fromCharCode(chr1);
  
            if (enc3 != 64) {
              output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
              output = output + String.fromCharCode(chr3);
            }
  
          }
  
          output = Base64._utf8_decode(output);
  
          return output;
  
        },
  
        _utf8_encode: function (string) {
          string = string.replace(/\r\n/g, "\n");
          var utftext = "";
          for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n);
            if (c < 128) {
              utftext += String.fromCharCode(c);
            }
            else if ((c > 127) && (c < 2048)) {
              utftext += String.fromCharCode((c >> 6) | 192);
              utftext += String.fromCharCode((c & 63) | 128);
            }
            else {
              utftext += String.fromCharCode((c >> 12) | 224);
              utftext += String.fromCharCode(((c >> 6) & 63) | 128);
              utftext += String.fromCharCode((c & 63) | 128);
            }
          }
  
          return utftext;
        },
  
        _utf8_decode: function (utftext) {
          var string = "";
          var i = 0;
          var c = c1 = c2 = 0;
          while (i < utftext.length) {
            c = utftext.charCodeAt(i);
            if (c < 128) {
              string += String.fromCharCode(c);
              i++;
            }
            else if ((c > 191) && (c < 224)) {
              c2 = utftext.charCodeAt(i + 1);
              string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
              i += 2;
            }
            else {
              c2 = utftext.charCodeAt(i + 1);
              c3 = utftext.charCodeAt(i + 2);
              string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
              i += 3;
            }
          }
          return string;
        }
      }
  
      function xEncode(data, key) {
        var r = "";
        var t = "";
        var m = 0;
        key += '';
        data = data.split("").reverse().join("");
        for (var i = 0, j = 0; i < data.length; i++) {
          t = data.charCodeAt(i) ^ key.charCodeAt(j) ^ m;
          r = r + String.fromCharCode(t);
          j = (++j) % key.length;
          m = t;
        }
        return window.btoa ? btoa(unescape(encodeURIComponent(r))) : Base64.encode(r);
      }
  
      var currentUrl = location.href, host = location.host, protocol = location.protocol;
      var baseUrl = currentUrl.split("?")[0];
      var targetPath = baseUrl.split(protocol + '//' + host);
  
      var oReport = {
        'ua': (platform + '&' + (targetPath[1] ? targetPath[1] : '')), // 根据url路径名判断
        'uid': getCookieVal('yyuid') || 0
      }
  
      var metricReport = function (m, timestamp, sguid) {
        var oAjax = null;
  
        if (window.XDomainRequest) {
          oAjax = new XDomainRequest();
        } else {
          oAjax = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
        }
        oReport.sguid = sguid || 0
        oReport.m = m;
  
        window.console && console.log(oReport);
        window.console && console.log(currentUrl);
  
        // APP日志打印
        window.HUYASdk && HUYASdk.log(window.location.pathname + ':' + JSON.stringify(oReport));
  
        var dataPost = JSON.stringify(oReport);
        var postData = xEncode(dataPost, timestamp);
        var url = server + 'ts=' + timestamp;
        oAjax.open('POST', url, true);
        // oAjax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        oAjax.send(postData);
      }
  
      //组织上报数据格式
      function handleReportData(obj, timestamp) {
        var p = [];
  
        for (var k in obj) {
  
          var item = {
            'name': 'fed.taf.performance',  // fed.page.index ： 前端组：TAF：指标
            'its': timestamp,
            'suc': obj[k] > 0 ? 1 : 0,
            'code': 0,
            'value': obj[k],
            'dim': {
              'path': k,
              'schema': schema
            },
            'exlog': {}
          }
  
          p.push(item);
  
        }
        return p;
      }
  
      function send(data) {
        var timestamp = +new Date();
        var m = handleReportData(data, timestamp);
        metricReport(m, timestamp);
      }
  
      if (metricData && Object.prototype.toString(metricData) == "[object Object]") {
        send(metricData)
      } else {
        console.log('[perfermanceReport(这里的参数需要是object)]!')
      }
    }
  
  
    var _iRequestId = 0;
    var reportOb = {};//拉取接口 上报
  
    function TafParser(obj) {
      // this.DEBUG_IP = 'testwebsocket.huya.com:8084';
      this.DEBUG_IP = 'testws.va.huya.com:80';
      this.DEF_IP = "wsapi.huya.com";
      this.CDN_IP = 'cdnws.api.huya.com';
      this.ws = null; //链接ws对象
      this.connectTimes = 0; //连接上的次数
      this.connected = false; //是否链接上
      this.countOfWS = 0; //ws链接的数量
      this.isIos = isIOS();
      this.isClosingLowerLink = false;//是否是进行关闭较慢的链接操作
      this.isActivity = true;//是否是活动，是则websocket链接后面加上'/activity'过滤，否则不加
      // this.cdnLink = "wss://" + this.CDN_IP + '/activity';
  
      //一级协议及对应的解包结构体方法
      this.uriStructs = {
        "1010003": HUYA.ActivityMsgRsp
      };
  
      //拉取接口及对应的解包结构体方法
      this.wupStructs = {
        "doLaunch": HUYA.LiveLaunchRsp,
        "getActivityMsg": HUYA.ActivityMsgRsp
      }
  
      this.initialize.apply(this, arguments);
    }
  
    TafParser.prototype = {
      constructor: TafParser,
      initialize: function (obj) {
        window.LINK_TIME_START = +new Date();
  
        var _this = this;
        this.initBaseParams(obj.base);
  
        this.PrintProtocolWarn = !!Number(localStorage._printProtocolWarn);
        this.PrintHeartBeat = !!Number(localStorage._printHeartBeat);
        this.uriStructs = this.extend(this.uriStructs, obj.uriStructs || {});
        this.wupStructs = this.extend(this.wupStructs, obj.wupStructs || {});
        //二级协议及对应的解包结构体方法
        this.actUris = obj.actUris || {};
  
        this.initEvent();
        this.connecting();
        this.addCommonListener();
  
        // if (!this.debug && typeof obj.report != 'undefined' && obj.report) {
        //     setTimeout(function() {
        //         _this.reportData(obj);
        //     }, obj.report.time || 10000);
        // }
        //隔10s上报数据
        if (obj && obj.base && !obj.base.debug) {
          setTimeout(function () {
            var value = window.LINK_TIME_ON - window.LINK_TIME_START;
            perfermanceReport({
              linkUpInfo: (value > 0 ? value : 0)
            })
          }, 10000);
        }
      },
      //上报数据(海度)
      reportData: function (obj) {
        var base = obj.base,
          report = obj.report;
        var report_info = {
          act: "webhuyamoneyh5",
          time: parseInt(Date.now() / 1000),
          platform: this.isIos ? 'ios' : 'android',
          yyuid: base.userId,
          anchor_id: base.anchorUid,
          status: linkStatus,
          consuming: linkUpTime,
          ip_adress: report.name
        };
  
        var query = "?";
        for (var key in report_info) {
          query += key + "=" + report_info[key] + "&";
        }
        var url = "//ylog.hiido.com/c.gif";
  
        var img = new Image();
        img.src = url + query;
  
        //向SDK上报数据
        HUYASdk && HUYASdk.log(("projectname:---" + report.name + "---websocket link report:" + JSON.stringify(report_info)));
      },
      //初始化必备的主播uid、频道id、子频道id、用户uid，及环境标识debug(正式/测试)
      initBaseParams: function (obj) {
        // if (!obj || Object.keys(obj).length < 4) {
        //   console.log('[TafParser debug]主播uid、频道id、子频道id、用户uid参数不全！');
        //   return;
        // }
  
        for (var key in obj) {
          this[key] = obj[key];
        }
      },
      // 发送wup请求
      sendWup: function (moduleName, funcName, data, iRequestId) {
        iRequestId = iRequestId || ++_iRequestId;
  
        var wup = new Taf.Wup();
        wup.setServant(moduleName);
        wup.setFunc(funcName);
        if (iRequestId) wup.setRequestId(iRequestId);
        data && wup.writeStruct('tReq', data);
  
        var req = new HUYA.WebSocketCommand();
        req.iCmdType = HUYA.EWebSocketCommandType.EWSCmd_WupReq;
        req.vData = wup.encode();
  
        var os = new Taf.JceOutputStream();
        req.writeTo(os);
        this.ws.send(os.getBuffer());
  
        if (window.performanceInfo && window.performanceInfo._hmt) {
          performanceInfo._hmt.push(['reportApiMess', 'tafWsConnect', 'sendWup:' + funcName, 200]);
        }
  
        //调用了getActivityMsg接口，则在第一个二级回包中添加上报,表示首屏上报
        // if(funcName == 'getActivityMsg' && window.performanceInfo && window.performanceInfo._hmt) {
        //     window.performanceInfo._hmt.push(['reportApiTime', 'firstPanel', 'start', +new Date()]);
        // }
  
        console.log('%c>>>>> %creqWup: %c' + funcName, logcss('#009100'), logcss('black'), logcss('#009100'), data);
      },
      sendWup2: function (moduleName, funcName, data, callback, once) {
        var _this = this;
        if (typeof callback === "function") {
          var wupCallback = function (backData) {
            callback(backData);
            if (once || once == undefined) {
              _this.removeListener(funcName, wupCallback);
            }
          };
          this.addListener(funcName, wupCallback);
        }
        this.sendWup(moduleName, funcName, data);
      },
      sendWup3: function (moduleName, funcName, data, callback, iRequestId) {
        var _this = this;
        if (typeof callback === "function") {
          var wupCallback = function (backData) {
            if (backData.iRequestId == iRequestId) {
              callback(backData);
              _this.removeListener(funcName, wupCallback);
            }
          };
          this.addListener(funcName, wupCallback);
        }
        this.sendWup(moduleName, funcName, data, iRequestId);
      },
      // Register请求
      sendRegister: function (data) {
        console.log('%c>>>>> %creqRegister:', logcss('#009100'), logcss('#D26900'), data);
  
        var os = new Taf.JceOutputStream();
        data.writeTo(os);
  
        var req = new HUYA.WebSocketCommand();
        req.iCmdType = HUYA.EWebSocketCommandType.EWSCmd_RegisterReq;
        req.vData = os.getBinBuffer();
  
        os = new Taf.JceOutputStream();
        req.writeTo(os);
        this.ws.send(os.getBuffer());
      },
      sendRegisterGroups: function (arr) {
        console.log("%c>>>>> %creqRegisterGroups:", logcss("#009100"), logcss("#D26900"), arr);
  
        var data = new HUYA.WSRegisterGroupReq();
        data.vGroupId.value = arr;
  
        var os = new Taf.JceOutputStream();
        data.writeTo(os);
  
        var req = new HUYA.WebSocketCommand();
        req.iCmdType = HUYA.EWebSocketCommandType.EWSCmdC2S_RegisterGroupReq;
        req.vData = os.getBinBuffer();
  
        os = new Taf.JceOutputStream();
        req.writeTo(os);
        this.ws.send(os.getBuffer());
      },
      sendUnRegisterGroups: function (arr) {
        console.log("%c>>>>> %creqUnRegisterGroups:", logcss("#009100"), logcss("#D26900"), arr);
  
        var data = new HUYA.WSUnRegisterGroupReq();
        data.vGroupId.value = arr;
  
        var os = new Taf.JceOutputStream();
        data.writeTo(os);
  
        var req = new HUYA.WebSocketCommand();
        req.iCmdType = HUYA.EWebSocketCommandType.EWSCmdC2S_UnRegisterGroupReq;
        req.vData = os.getBinBuffer();
  
        os = new Taf.JceOutputStream();
        req.writeTo(os);
        this.ws.send(os.getBuffer());
      },
      initEvent: function () {
  
        var _listeners = {};
        // 添加
        this.addListener = function (type, fn) {
          var eventArray = [];
          if (typeof type == 'string' && type.indexOf(' ') != -1) {
            eventArray = type.split(' ');
          } else {
            eventArray.push(type);
          }
          for (var i = 0; i < eventArray.length; i++) {
            var ev = eventArray[i];
            if (typeof _listeners[ev] === 'undefined') {
              _listeners[ev] = [];
            }
            if (typeof fn === 'function') {
              _listeners[ev].push(fn);
            }
          }
          return this;
        };
        // 触发
        this.dispatch = function (type, parmobj) {
          var arrayEvent = _listeners[type];
          if (arrayEvent instanceof Array) {
            for (var i = 0, length = arrayEvent.length; i < length; i += 1) {
              if (typeof arrayEvent[i] === 'function') {
                arrayEvent[i](parmobj);
              }
            }
          } else {
            if (!arrayEvent) {
              console.info('收到未处理数据', type, parmobj);
            }
          }
          return this;
        };
        // 删除
        this.removeListener = function (type, fn) {
          var arrayEvent = _listeners[type];
          if (typeof type === 'string' && arrayEvent instanceof Array) {
            if (typeof fn === 'function') {
              for (var i = 0, length = arrayEvent.length; i < length; i += 1) {
                if (arrayEvent[i] === fn) {
                  _listeners[type].splice(i, 1);
                  break;
                }
              }
            } else {
              delete _listeners[type];
            }
          }
          return this;
        };
      },
      addCommonListener: function () {
        var _this = this;
        //WebSocket 连接成功
        this.addListener('WEBSOCKET_CONNECTED', function (data) {
          console.log('---WebSocket 连接成功---')
          _this._doLaunch();
          _this._doRegister(data.iValidate);
          var groups = _this.listenGroups;
          if (groups && groups.length) {
            _this.sendRegisterGroups(groups);
          }
          if (window.performanceInfo && window.performanceInfo._hmt) {
            performanceInfo._hmt.push(['reportApiMess', 'tafWsConnect', 'doRegister', 200]);
          }
        });
  
        this.addListener('WSRegisterRsp', function () {
          console.log('---注册成功---');
          _this._OnUserEvent();
        });
  
        this.addListener('WSRegisterGroupRsp', function () {
          console.log('---注册成功---');
          _this._OnUserEvent();
        });
  
        this.addListener('OnClientReady', function (data) {
          console.log('---进频道成功---');
        });
  
        // 监听doLaunch事件，获取动态ip
        this.addListener("doLaunch", function (data) {
          _this._checkLocalCache();
  
          var ipArr = data.vProxyList.value,
            ipTarget = {};
          for (var i = 0, len = ipArr.length; i < len; i++) {
            var item = ipArr[i];
            if (item.eProxyType == 5) {
              ipTarget.data = item.sProxy.value;
              ipTarget.preTime = new Date().getTime();
  
              localStorage.setItem('ysHdDomainCache1', JSON.stringify(ipTarget));
              break;
            }
          }
        });
      },
      getConnetLink: function () {
        var domainCache = JSON.parse(localStorage.getItem('ysHdDomainCache1')),
          connectingLink = null,
          cndLink = "wss://" + this.CDN_IP + (this.isActivity ? '/activity' : '');
  
        //如有缓存ip协议，使用ip协议和cdn进行双线链接，哪个先连上用哪个;没有的话直接用cdn连
        if (domainCache && domainCache.data) {
          //打乱数组并随机取出其中的域名进行链接
          var messDomainArr = mess(domainCache.data);
          var randomIndex = Math.floor(Math.random() * messDomainArr.length);
  
          connectingLink = "wss://" + messDomainArr[randomIndex] + (this.isActivity ? '/activity' : '');
        }
  
        return connectingLink ? [connectingLink, cndLink] : [cndLink]
      },
      connecting: function (useCdnLink) {
        if (this.connected) return;
  
        if (!this.debug) {
          //重置链接数量
          this.countOfWS = 0;
  
          if (useCdnLink) {
            this.realConnecting("wss://" + this.CDN_IP + (this.isActivity ? '/activity' : ''));
          } else {
            var connectingLinks = this.getConnetLink(),
              self = this;
  
            connectingLinks.forEach(function (item) {
              console.log('当前使用的ip是---' + item);
              self.realConnecting(item)
            })
          }
  
        } else {
          this.realConnecting("ws://" + this.DEBUG_IP + (this.isActivity ? '/activity' : ''))
        }
      },
      realConnecting: function (connectingLink) {
        var self = this,
          hearBeatTimeout = null; //close的时候应该停止心跳包的发送
        var linkTimeStart = Date.now(),
          ws = null;
  
        ws = new WebSocket(connectingLink);
  
        ws.onopen = function onopen(evt) {
          console.log("=== WebSocket Connected ===", evt.currentTarget.url);
  
          if (self.connected) {
            self.isClosingLowerLink = true;
            ws.close();
            return;
          }
          if (!self.debug) self.countOfWS++;
  
          console.log("=== The faster connected domain is ===" + connectingLink);
          self.connected = true;
          self.connectTimes = 0;
          self.ws = ws;
  
          //用于上报的链接状态，和连接上所用耗时
          // var linkTimeOn = Date.now();
          // linkStatus = 'on';
          // linkUpTime = linkTimeOn - linkTimeStart;
          window.LINK_TIME_ON = +new Date();
  
          self.VerifyCookie(ws);
  
          clearInterval(hearBeatTimeout);
          hearBeatTimeout = setInterval(self.HeartBeat.bind(self, ws), 60000); //心跳包(这里注意要使用bind绑定作用域)
  
          //上报链接的ws域名
          if (window.performanceInfo && window.performanceInfo._hmt) {
            performanceInfo._hmt.push(['reportApiMess', 'tafWsConnect', connectingLink, 10086]);
          }
        };
  
        ws.onclose = function onclose(evt) {
          console.warn("=== WebSocket Closed ===", evt.currentTarget.url);
          console.log("=== ws 链接数量 ===>" + self.countOfWS)
          clearInterval(hearBeatTimeout);
  
          //对于就关闭较慢链接的操作不需要做重连
          if (self.isClosingLowerLink) {
            self.isClosingLowerLink = false;
            return;
          }
  
          if (self.countOfWS <= 1) {
            self.connected = false;
            self.connectTimes++;
  
            console.log('=== 重连次数 ===' + self.connectTimes)
            //在发生onerror导致的关闭时重新初始化
            if (self.connectTimes <= 100) {
              ws = null;
              console.log('=== 隔2秒重连 ===');
              setTimeout(function () {
                self.connecting(true);
              }, 2000);
  
              if (window.performanceInfo && window.performanceInfo._hmt) {
                performanceInfo._hmt.push(['reportApiMess', 'tafWsConnect', 'reConnect' + self.connectTimes, 200]);
              }
            } else {
              if (window.performanceInfo && window.performanceInfo._hmt) {
                performanceInfo._hmt.push(['reportApiMess', 'tafWsConnect', 'reConnectCountTimeout', -1]);
              }
            }
          } else {
            self.countOfWS = 0;
          }
        };
  
        ws.onerror = function (evt) {
          console.warn("=== WebSocket Error ===", evt.currentTarget.url);
          clearInterval(hearBeatTimeout);
          if (self.connected) ws.close();
          if (self.countOfWS === 1) self.connected = false;
        };
  
        ws.onmessage = function onmessage(evt) {
          // Blob -> ArrayBuffer
          if (evt.data instanceof Blob) {
            var fileReader = new FileReader();
            fileReader.onload = function (event) {
              self.handleOnMessage(this.result);
            };
  
            fileReader.onerror = function (err) {
              // output(JSON.stringify(err));
            }
  
            fileReader.readAsArrayBuffer(evt.data);
          } else {
            self.handleOnMessage(evt.data);
          }
        };
      },
      handleOnMessage: function (arrayBuffer) {
        var is = new Taf.JceInputStream(arrayBuffer);
        var rsp = new HUYA.WebSocketCommand();
        rsp.readFrom(is);
  
        switch (rsp.iCmdType) {
          case HUYA.EWebSocketCommandType.EWSCmd_RegisterRsp: // 注册
            is = new Taf.JceInputStream(rsp.vData.buffer);
            var registerRsp = new HUYA.WSRegisterRsp();
            registerRsp.readFrom(is);
            console.log('%c<<<<< %crspRegister', logcss('#0000E3'), logcss('#D9006C'), registerRsp);
            this.dispatch('WSRegisterRsp', registerRsp);
            break;
  
          case HUYA.EWebSocketCommandType.EWSCmdS2C_RegisterGroupRsp:
            is = new Taf.JceInputStream(rsp.vData.buffer);
            var registerGroup = new HUYA.WSRegisterGroupRsp();
            registerGroup.readFrom(is);
            console.log("%c<<<<< %crspregisterGroup", logcss("#0000E3"), logcss("#D9006C"), registerGroup);
            this.dispatch("WSRegisterGroupRsp", registerGroup);
            break;
  
          case HUYA.EWebSocketCommandType.EWSCmdS2C_UnRegisterGroupRsp:
            is = new Taf.JceInputStream(rsp.vData.buffer);
            var unRegisterGroup = new HUYA.WSUnRegisterGroupRsp();
            unRegisterGroup.readFrom(is);
            console.log("%c<<<<< %crspunRegisterGroup", logcss("#0000E3"), logcss("#D9006C"), unRegisterGroup);
            this.dispatch("WSUnRegisterGroupRsp", unRegisterGroup);
            break;
  
          case HUYA.EWebSocketCommandType.EWSCmd_WupRsp: // wup协议
            var wup = new Taf.Wup();
            wup.decode(rsp.vData.buffer);
  
            var WupStruct = this.wupStructs[wup.sFuncName];
            if (WupStruct) {
              var wupStruct = new WupStruct();
              var key = wup.newdata.get('tRsp') ? 'tRsp' : 'tResp';
  
              try {
                wup.readStruct(key, wupStruct, WupStruct);
              } catch (e) {
                console.error(wup, wupStruct, key, e);
                return;
              }
              if (wup.iRequestId) {
                wupStruct.iRequestId = wup.iRequestId;
              }
              console.log('%c<<<<< %crspWup:%c ' + wup.sFuncName, logcss('#0000E3'), logcss('black'), logcss('#0000E3'), wupStruct);
  
              //拉取消息经过wup.readStruct解析一次后，还需要对里面的内容再解析一次得到最终的结果
              if (wup.sFuncName === 'getActivityMsg' || wup.sFuncName === 'getActivityTorMsg') {
                this._analySerializedMsg(wupStruct, wup.iRequestId, true)
              } else {
                this.dispatch(wup.sFuncName, wupStruct);
              }
            } else {
              this.dispatch(wup.sFuncName);
              if (wup.sFuncName != 'OnClientReady') {
                console.info('收到未映射的WupRsp, sFuncName=' + wup.sFuncName);
              }
            }
  
            if (window.performanceInfo && window.performanceInfo._hmt) {
              performanceInfo._hmt.push(['reportApiMess', 'tafWsConnect', 'WupRsp:' + wup.sFuncName, 200]);
            }
  
            break;
          case HUYA.EWebSocketCommandType.EWSCmdS2C_MsgPushReq: // 推送
            is = new Taf.JceInputStream(rsp.vData.buffer);
            var pushMess = new HUYA.WSPushMessage();
            pushMess.readFrom(is);
            is = new Taf.JceInputStream(pushMess.sMsg.buffer);
  
            var iUri = pushMess.iUri;
            var UriStruct = this.uriStructs[iUri];
            if (UriStruct) {
              var uriStruct = new UriStruct();
              uriStruct.readFrom(is);
              console.log('%c<<<<< %crspMsgPush, %ciUri=' + iUri, logcss('0#0000E3'), logcss('black'), logcss('#8600FF'), uriStruct);
  
              //协议是否有效
              // if(!uriStruct.iEnable) return;
  
              if (iUri === 1010003 || iUri === 1010005) {
                this._analySerializedMsg(uriStruct)
              } else {
                this.dispatch(iUri, uriStruct);
              }
            } else if (this.PrintProtocolWarn) {
              console.info("收到未映射的 WSPushMessage uri=" + iUri);
            }
            break;
  
          case HUYA.EWebSocketCommandType.EWSCmdS2C_MsgPushReq_V2:
            is = new Taf.JceInputStream(rsp.vData.buffer);
            var pushMess = new HUYA.WSPushMessage_V2();
            pushMess.readFrom(is);
            for (var i = 0, len = pushMess.vMsgItem.value.length; i < len; i++) {
              var data = pushMess.vMsgItem.value[i];
              var uri = data.iUri;
              var uriClass = this.uriStructs[uri];
              if (uriClass) {
                var uriStruct = new uriClass();
                var is = new Taf.JceInputStream(data.sMsg);
                uriStruct.readFrom(is);
  
                console.log("%c<<<<< %crspMsgPushV2, %curi=" + uri, logcss("#0000E3"), logcss("black"), logcss("#8600FF"), uriStruct);
  
                if (uri === 1010003 || uri === 1010005) {
                  this._analySerializedMsg(uriStruct)
                } else {
                  this.dispatch(uri, uriStruct);
                }
  
                this.dispatch(uri, uriStruct);
              } else if (this.PrintProtocolWarn) {
                console.info("收到未映射的 WSPushMessage_V2 uri=" + uri);
              }
            }
            break;
  
          case HUYA.EWebSocketCommandType.EWSCmdS2C_HeartBeatRsp: // 心跳返回
            if (this.PrintHeartBeat) {
              console.log('%c<<<<< rspHeartBeat: ' + Date.now().toLocaleString(), logcss('#0000E3'));
            }
            break;
          case HUYA.EWebSocketCommandType.EWSCmdS2C_HeartBeatAck:
            if (this.PrintHeartBeat) {
              console.log("%c<<<<< ackHeartBeat: " + Date.now().toLocaleString(), logcss("#0000E3"));
            }
            break;
          case HUYA.EWebSocketCommandType.EWSCmdS2C_VerifyCookieRsp: //验证返回
            is = new Taf.JceInputStream(rsp.vData.buffer);
            var verifyRsp = new HUYA.WSVerifyCookieRsp();
            verifyRsp.readFrom(is);
            var isPass = verifyRsp.iValidate === 0;
  
            this.dispatch('WEBSOCKET_CONNECTED', verifyRsp);
            console.log('%c<<<<< %cVerifyCookie', logcss('#0000E3'), logcss('#D9006C'), '校验' + (isPass ? '通过！' : '失败！'), verifyRsp);
            break;
          default:
            console.warn('%c<<<<< Not matched CmdType: ' + rsp.iCmdType, logcss('#red'));
        }
      },
      _analySerializedMsg: function (rsp, iReqId, isGetActMsg) {
        var enterMsgs = rsp.vSerializedMsg.value;
  
        for (var i = 0, len = enterMsgs.length; i < len; i++) {
          var temp = enterMsgs[i],
            msgUri = temp.iSubUri,
            panelMessage,
            is = new Taf.JceInputStream(temp.vContent);
  
          if (!this.actUris[msgUri]) continue;
  
          panelMessage = new this.actUris[msgUri]();
          try {
            panelMessage.readFrom(is);
          } catch (e) {
            console.error(msgUri, panelMessage, e);
            continue;
          }
  
          if (iReqId) {
            panelMessage.iRequestId = iReqId;
          }
  
          this.dispatch(msgUri, panelMessage);
  
  
          //调用了getActivityMsg接口，则在第一个二级回包中添加上报,表示首屏上报
          // if(i === 0 && isGetActMsg && window.performanceInfo && window.performanceInfo._hmt) {
          //     window.performanceInfo._hmt.push(['reportApiTime', 'firstPanel', 'end', +new Date()]);
          // }
        }
      },
      //ip连接需要验证cookie
      VerifyCookie: function () {
        var yyuid = this.userId,
          isAnonymity = parseInt(yyuid) >= 2084428900;
        //if (!yyuid) return;
        var data = new HUYA.WSVerifyCookieReq();
        data.lUid = yyuid;
        data.sUA = "webh5&1.2.3&websocket";
        data.sCookie = isAnonymity ? document.cookie : (document.cookie + ';yyuid=' + yyuid);
  
        var os = new Taf.JceOutputStream();
        data.writeTo(os);
  
        var req = new HUYA.WebSocketCommand();
        req.iCmdType = HUYA.EWebSocketCommandType.EWSCmdC2S_VerifyCookieReq;
        req.vData = os.getBinBuffer();
  
        os = new Taf.JceOutputStream();
        req.writeTo(os);
        this.ws.send(os.getBuffer());
  
        console.log('%c>>>>> %cVerifyCookie:', logcss("#009100"), logcss("#D26900"), data);
      },
      //心跳包
      HeartBeat: function () {
        if (!this.connected) return;
  
        var req = new HUYA.WebSocketCommand();
        req.iCmdType = HUYA.EWebSocketCommandType.EWSCmdC2S_HeartBeatReq;
  
        var os = new Taf.JceOutputStream();
        req.writeTo(os);
  
        this.ws && this.ws.send(os.getBuffer());
  
        if (window.performanceInfo && window.performanceInfo._hmt) {
          performanceInfo._hmt.push(['reportApiMess', 'tafWsConnect', 'HeartBeat', 200]);
        }
  
        if (this.PrintHeartBeat) {
          console.log('%c>>>>> reqHeartBeat: ' + new Date().toLocaleString(), logcss('#009100'));
        }
      },
      _checkLocalCache: function () {
        try {
          var cacheIpObj = JSON.parse(localStorage.getItem('ysHdDomainCache1'));
  
          if (cacheIpObj && cacheIpObj.preTime) {
            //设置过期时间
            var preTime = cacheIpObj.preTime,
              now = new Date().getTime(),
              expireTime = 24 * 60 * 60; //过期时间设置为1天
  
            if ((now - preTime) > expireTime) {
              localStorage.removeItem('ysHdDomainCache1');
            }
          }
        } catch (e) {
          console.log(e)
        }
      },
      _doRegister: function (validate) {
        //console.log('verify---------->>>>>' + validate)
        var req = new HUYA.WSUserInfo();
        req.lTid = this.channelId || 0;
        req.lSid = this.subChannelId || 0;
  
        this.validate = validate == 0;
        req.lUid = this.userId || this.getCookie('yyuid') || 0;
        req.bAnonymous = false;
        this.sendRegister(req);
      },
      _doLaunch: function () {
        var req = new HUYA.LiveLaunchReq();
        req.tLiveUB.eSource = HUYA.ELiveSource.WEB_HUYA;
        //新加的设置，用于获取批量下发的域名(https+wss)
        var reqUserId = new HUYA.UserId();
        reqUserId.lUid = this.userId;
        reqUserId.sHuYaUA = 'webh5&' + (this.onLineTime || '1.0.0') + '&huodong';
        req.bSupportDomain = 1;
        req.tId = reqUserId;
  
        this.sendWup("liveui", "doLaunch", req);
  
        if (window.performanceInfo && window.performanceInfo._hmt) {
          performanceInfo._hmt.push(['reportApiMess', 'tafWsConnect', 'doLaunch', 200]);
        }
      },
      //用户进入频道
      _OnUserEvent: function () {
        if (this.alreadyEnterChannel) return;
        this.alreadyEnterChannel = true;
  
        var req = new HUYA.EnterChannelReq();
        req.tUserId.sGuid = this.getCookie('guid') || '';
        req.tUserId.lUid = this.userId || this.getCookie('yyuid') || 0;
        req.tUserId.sCookie = document.cookie;
        req.tUserId.sHuYaUA = 'webh5&' + (this.onLineTime || '1.0.0') + '&huodong';
        req.lTid = this.channelId || 0;
        req.lSid = this.subChannelId || 0;
        //console.log("用户进入频道--参数")
        this.sendWup("ActivityUIServer", "OnClientReady", req);
      },
      extend: function (target, obj) {
        for (var key in obj) {
          target[key] = obj[key];
        }
  
        return target;
      },
      getCookie: function (cookieName) {
        var cookieString = document.cookie;
        var cookies = cookieString.split(';');
        for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i];
          var start = cookie.indexOf(cookieName + '=');
          if (start == -1 || start > 1) continue;
          start += cookieName.length + 1;
          return cookie.substring(start);
        }
        return null;
      }
    }
  
    function ServiceChannel() {
      //一级协议及对应的解包结构体方法
      this.uriStructs = {
        "1010003": HUYA.ActivityMsgRsp
      };
  
      //拉取接口及对应的解包结构体方法
      this.wupStructs = {
        "doLaunch": HUYA.LiveLaunchRsp,
        "getActivityMsg": HUYA.ActivityMsgRsp,
      }
  
      this.initialize.apply(this, arguments);
    }
  
    ServiceChannel.prototype = {
      constructor: ServiceChannel,
      initialize: function (obj) {
        console.log('>>>[ServiceChannel initialize]>>>')
        if (obj.base) {
          for (var key in obj.base) {
            this[key] = obj.base[key];
          }
        }
  
        this.actUris = obj.actUris || {};
        this.uriStructs = this.extend(this.uriStructs, obj.uriStructs || {});
        this.wupStructs = this.extend(this.wupStructs, obj.wupStructs || {});
  
        this.initEvent();
        this.initWupTransmitEvent();
      },
      initEvent: function () {
        var _listeners = {};
        // 添加
        this.addListener = function (type, fn) {
          var eventArray = [];
          if (typeof type == 'string' && type.indexOf(' ') != -1) {
            eventArray = type.split(' ');
          } else {
            eventArray.push(type);
          }
          for (var i = 0; i < eventArray.length; i++) {
            var ev = eventArray[i];
            if (typeof _listeners[ev] === 'undefined') {
              _listeners[ev] = [];
            }
            if (typeof fn === 'function') {
              _listeners[ev].push(fn);
            }
          }
          return this;
        };
        // 触发
        this.dispatch = function (type, parmobj) {
          var arrayEvent = _listeners[type];
          if (arrayEvent instanceof Array) {
            for (var i = 0, length = arrayEvent.length; i < length; i += 1) {
              if (typeof arrayEvent[i] === 'function') {
                arrayEvent[i](parmobj);
              }
            }
          } else {
            if (!arrayEvent) {
              console.info('收到未处理数据', type, parmobj);
            }
          }
          return this;
        };
        // 删除
        this.removeListener = function (type, fn) {
          var arrayEvent = _listeners[type];
          if (typeof type === 'string' && arrayEvent instanceof Array) {
            if (typeof fn === 'function') {
              for (var i = 0, length = arrayEvent.length; i < length; i += 1) {
                if (arrayEvent[i] === fn) {
                  _listeners[type].splice(i, 1);
                  break;
                }
              }
            } else {
              delete _listeners[type];
            }
          }
          return this;
        };
      },
      initWupTransmitEvent: function () {
        var uriStructs = this.uriStructs,
          subUris = Object.keys(uriStructs),
          _this = this,
          isIos = isIOS();
  
        //由于IOS客户端和sdk都监听了HUYASdk.EVENT_ID.TRANSMIT事件，导致推送消息重复推送了，所以在这里先移除掉
        // isIos && HUYASdk.removeEventListener(HUYASdk.EVENT_ID.TRANSMIT);
  
        HUYASdk.addEventListener(HUYASdk.EVENT_ID.WUP_TRANSMIT, {
          subUris: Object.keys(uriStructs) || []
        }, function (resp) {
          var subUri = resp.subUri,
            tempRsp;
  
          // if(window.performanceInfo && window.performanceInfo._hmt) {
          //     performanceInfo._hmt.push(["reportApiMess", "channelConnect", 'boardCastRespond>>>' + resp, 200]);
          // }
  
          HUYASdk && HUYASdk.log('subUri-' + subUri);
  
          if (subUri) {
            //从uriStructs中取出对应的一级协议的解包结构体方法
            for (var key in uriStructs) {
              if (key == subUri) {
                tempRsp = uriStructs[key]
              }
            }
  
            if (tempRsp) {
              var is = new Taf.JceInputStream(resp.data);
              var rsp = new tempRsp();
              rsp.readFrom(is);
  
              if (subUri == 1010003 || subUri == 1010005) {
                _this.analySerializedMsg(rsp)
              } else {
                _this.dispatch(subUri, rsp);
              }
            }
          }
        });
      },
  
      getWupStructByArrayBuffer: function (arrayBuffer, rspClass) {
        var wup = new Taf.Wup();
        wup.decode(arrayBuffer);
  
        var key = wup.newdata.get("tRsp") ? "tRsp" : "tResp";
        var wupStruct = new rspClass();
        wup.readStruct(key, wupStruct, rspClass);
        return wupStruct;
      },
      createArrayBufferByWupReq: function (serventName, func, data, iRequestId) {
        var wup = new Taf.Wup();
        wup.setServant(serventName);
        wup.setFunc(func);
  
        if (iRequestId) wup.setRequestId(iRequestId);
        if (data) wup.writeStruct("tReq", data);
  
        var os = wup.encode();
  
        return os.getBuffer();
      },
  
      /**
       * @moduleName: 服务端的协议UI
       * @reqData: 请求的参数数据
       */
      sendWup: function (moduleName, funcName, reqData, iRequestId) {
        iRequestId = iRequestId || ++_iRequestId;
  
        var arrayBuffer = this.createArrayBufferByWupReq(moduleName, funcName, reqData, iRequestId),
          _this = this, startTime = +new Date();
  
        console.log('>>>[ServiceChannel]sendWup:moduleName->' + moduleName + ';funcName=' + funcName)
  
        if (iRequestId) {
          //添加拉取接口上报
          reportOb[funcName + '-' + iRequestId] = startTime;
  
          if (window.performanceInfo && window.performanceInfo._hmt) {
            performanceInfo._hmt.push(['reportApiTime', 'taf-' + moduleName + '-' + funcName, 'start', startTime, '', startTime]);
          }
        }
  
        //调用了getActivityMsg接口，则在第一个二级回包中添加上报,表示首屏上报
        if (funcName == 'getActivityMsg' && window.performanceInfo && window.performanceInfo._hmt) {
          window.performanceInfo._hmt.push(['reportApiTime', 'taf-ActivityUI-firstPanel', 'start', +new Date()]);
        }
  
        (function (rid) {
          HUYASdk && HUYASdk.sendWupRequest({
            unitPacket: arrayBuffer, //必须是uniPacket的ArrayBuffer
            userInfo: {}, //只支持对象
            success: function (resp) {
              var launchRsp = _this.getWupStructByArrayBuffer(resp.data, _this.wupStructs[funcName]);
  
              console.log('>>>[ServiceChannel]sendWup:success callback>>>')
  
              if (rid) {
                //添加拉取接口上报
                var targetApiReportSign = reportOb[funcName + '-' + rid];
                if (targetApiReportSign) {
                  if (window.performanceInfo && window.performanceInfo._hmt) {
                    performanceInfo._hmt.push(['reportApiTime', 'taf-' + moduleName + '-' + funcName, 'end', +new Date(), '', targetApiReportSign]);
                  }
                }
              }
  
              if (funcName === 'getActivityMsg' || funcName === 'getActivityTorMsg') {
                _this.analySerializedMsg(launchRsp, rid, true)
              } else {
                if (iRequestId) launchRsp.iRequestId = rid;
                _this.dispatch(funcName, launchRsp);
              }
            }
          });
        })(iRequestId)
      },
  
      sendWup2: function (moduleName, funcName, data, callback, once) {
        var _this = this;
  
        if (typeof callback === "function") {
          var wupCallback = function (backData) {
            callback(backData);
            if (once || once == undefined) {
              _this.removeListener(funcName, wupCallback);
            }
          };
          this.addListener(funcName, wupCallback);
        }
        this.sendWup(moduleName, funcName, data);
      },
  
      analySerializedMsg: function (rsp, iRequestId, isGetActMsg) {
        var enterMsgs = rsp.vSerializedMsg.value;
  
        for (var i = 0, len = enterMsgs.length; i < len; i++) {
          var temp = enterMsgs[i],
            msgUri = temp.iSubUri,
            panelMessage,
            is = new Taf.JceInputStream(temp.vContent);
  
          if (!this.actUris[msgUri]) continue;
  
          panelMessage = new this.actUris[msgUri]();
          try {
            panelMessage.readFrom(is);
          } catch (e) {
            console.error(msgUri, panelMessage, e);
            continue;
          }
  
          if (iRequestId) panelMessage.iRequestId = iRequestId;
  
          this.dispatch(msgUri, panelMessage);
  
          //调用了getActivityMsg接口，则在第一个二级回包中添加上报,表示首屏上报
          if (i === 0 && isGetActMsg && window.performanceInfo && window.performanceInfo._hmt) {
            window.performanceInfo._hmt.push(['reportApiTime', 'taf-ActivityUI-firstPanel', 'end', +new Date()]);
          }
        }
      },
      isPlainObject: function (ob) {
        var a = [];
        for (var key in ob) {
          if (ob.hasOwnProperty(key)) {
            a.push(key);
          }
        }
  
        return a.length === 0;
      },
      extend: function (target, obj) {
        for (var key in obj) {
          target[key] = obj[key];
        }
  
        return target;
      }
    }
  
    /**
     * 调用方式:
      new WSChannel({
        base:{
            debug: true,
            anchorUid:anchorUid, //主播uid
            channelId:channelId, //频道id
            subChannelId:subChannelId, //子频道id
            userId:userId,  //用户id
            listenGroups:[]  //进组
        },
        //一级协议及对应的解包结构体方法
        uriStructs: { 
            1010003: HUYA.ActivityMsgRsp,
            1010002: HUYA.ActivityBroadcastNotice
        },
        //二级协议及对应的解包结构体方法
        actUris: { 
            20180301: ActOldDriver.AnchorPanel,
            20180302: ActOldDriver.TripRank
        },
        //拉取接口及对应的解包结构体方法
        wupStructs: { 
            "getActivityMsg": HUYA.ActivityMsgRsp,
        },
        success: function(result) {
            
        }
      })
     *
     *
    */
  
    //通过adk获取的各app的名称
    var APP_NAME = {
      GAME_IOS: 'hyassist4game-ios',//手游IOS
      GAME_ADR: 'game-adr',//手游Adr
      LIVE_IOS: 'live-ios',//助手IOS
      LIVE_ADR: 'live-adr',//助手Adr
      IOS: 'kiwi-ios',//观众端IOS
      ADR: 'kiwi-android'//观众端Adr
    };
  
    function WSChannel(obj) {
      this.initialize.apply(this, arguments);
    }
  
    WSChannel.prototype = {
      constructor: WSChannel,
      initialize: function (obj) {
        var ob = null,
          debug = obj.base.debug,
          callback = obj.success;
  
        window.ISDEBUG = debug;
  
        //是否强制使用Taf
        if (obj.base.useTaf || obj.base.useWebSocket) {
          if (callback) {
            ob = new TafParser(obj);
  
            handleTafCallback(callback, ob)
          } else {
            console.log("warning: 初始化WSCHannel缺少success回调!!")
          }
        } else {
          // var url = location.href;
          //此时认为是app环境，否则认为是本地开发环境->使用taf
          // if (url.indexOf('anchorYYId') > 0 && url.indexOf('yyuid') > 0) { //不能用这种方式，因为有些需求不会配置参数的
          var urlDebug = getURLParam('debug'); //url中没有debug参数代表非本地开发环境，否者是app环境：通过版本判断是用taf还是channel
          if (!urlDebug && HUYASdk) {
            HUYASdk.getAppInfo({
              complete: function (resp) {
                var isIos = isIOS();
                var version = resp.appVersion,
                  appName = resp.appName,
                  adrVersion = '5.08.3', //默认观众端支持channel版本
                  iosVersion = '5.08.0',
                  isTaf = false, client = '观众端';
  
  
                if (appName == APP_NAME['GAME_IOS'] || appName == APP_NAME['GAME_ADR']) {//手游
                  adrVersion = '5.08.3',
                    iosVersion = '5.08.0',
                    client = '手游';
                } else if (appName == APP_NAME['LIVE_IOS'] || appName == APP_NAME['LIVE_ADR']) {//助手
                  adrVersion = '1.26.0',
                    iosVersion = '1.26.0',
                    client = '助手';
                }
  
                console.log(('[当前' + (isIos ? 'IOS' : 'Adr') + '的APP版本是]' + version + ', 为' + client + '端'))
  
                if (resp && version) {
                  if ((!isIos && versionfunegt(version, adrVersion)) || (isIos && versionfunegt(version, iosVersion))) {
                    ob = new ServiceChannel(obj);
                    isTaf = false;
                  } else {
                    isTaf = true;
                    ob = new TafParser(obj);
                  }
                } else {
                  isTaf = true;
                  ob = new TafParser(obj);
                }
  
                console.log('[当前使用的模式是]' + (isTaf ? 'TAF' : 'ServiceChannel'))
  
                if (isTaf) {
                  handleTafCallback(callback, ob)
                } else {
                  callback && callback({
                    isTaf: isTaf,
                    wscOb: ob
                  });
                }
              }
            });
          } else {
            if (callback) {
              ob = new TafParser(obj);
  
              handleTafCallback(callback, ob)
            } else {
              console.log("warning: 初始化WSCHannel缺少success回调!!")
            }
          }
        }
  
        //taf情况下:使用定时器来判断ws是否初始化完成，只有ws初始化完成才调用回调返回
        function handleTafCallback(callback, tafOb) {
          var maxMin = 60 * 1000,
            startTime = +new Date();
  
          var timeout = setInterval(function () {
            if (tafOb && tafOb.ws) {
              callback({
                isTaf: true,
                wscOb: tafOb
              })
  
              clearInterval(timeout);
            }
  
            if ((+new Date()) - startTime > maxMin) {
              clearInterval(timeout);
            }
          }, 200);
        }
      }
    }
  
    window.WSChannel = WSChannel;
  })();
  
  
  